<template>
  <div v-if="showNoDataImgForUser">
    <div class="progressImgDataContainer">
      <div class="progressDataText">
        <h4>Your data has been successfully added to Weavr!</h4>
        <p>Please check back in 24 hours.</p>
      </div>
      <div class="progressImgWrapper">
        <img
          src="Icons_SVG/progressDataImgUpdated.svg"
          alt="data in progress"
        />
      </div>
    </div>
  </div>
  <div v-else id="product-reviews">
    <div
      v-show="
        loader ||
        reviewLoader ||
        countLoader ||
        vocLoader ||
        topProductsLoaderForTabs ||
        loaderUpdated
      "
    >
      <Loader />
    </div>
    <div
      class="card datepickerwrap mt-4 d-flex flex-row justify-content-between"
    >
      <div class="d-flex flex-row gap  tw-flex-wrap">
        <div>
          <div class="mb-1 ml-1 label">
            {{ translatedLang["Date Range"][selectedLanguage.key] }}
          </div>
          <date-range-picker
            v-model="dateRange"
            :show-dropdowns="true"
            opens="right"
            :autoApply="true"
            :locale-data="{ format: 'dd mmm yyyy' }"
            :min-date="minDate"
            :max-date="maxDate"
            :ranges="false"
            @update="getProductIdData"
          >
          </date-range-picker>
        </div>
        <div
          class="customMultiselectCommon"
          v-if="platforms.length"
          style="min-width: 170px; max-width: 200px"
        >
          <div class="mb-1 ml-1 label">
            {{ translatedLang["Platform"][selectedLanguage.key] }}
          </div>
          <div class="">
            <multiselect
              v-model="selectedPlatform"
              :custom-label="updateSelectedLabels"
              @input="changePlatform"
              :options="platforms"
              :multiple="false"
              :searchable="false"
              placeholder="Select Platform"
              label="platform_name"
              track-by="platform_id"
              :showLabels="false"
              :close-on-select="true"
              class="text-capitalize"
            >
              <template #option="{ option }">
                <div class="custom-option text-capitalize">
                  {{ option.platform_name.replaceAll("_", " ") }}
                </div>
              </template>
            </multiselect>
          </div>
        </div>
        <!-- <div v-if="Object.keys(categories).length">
          <div class="mb-1 ml-1 label">
            {{ translatedLang["Category"][selectedLanguage.key] }}
          </div>
          <div class="customMultiselect" style="width: 250px"> -->
        <!-- <multiselect
              v-model="selectedCategory"
              :options="categories[selectedPlatform.platform_id]"
              :multiple="false"
              :searchable="false"
              placeholder="Select Categories"
              label="value"
              track-by="key"
              :showLabels="false"
              :close-on-select="true"
              @input="handleCategory"
            > -->
        <!-- <template #selection="{ values, search, isOpen }">
                                <span class="multiselect__single" v-if="values.length" v-show="!isOpen">
                                    {{ values.length }} options selected
                                </span>
                            </template> -->
        <!-- </multiselect> -->
        <!-- </div>
        </div> -->
        <div
          class="customMultiselectCommon"
          style="min-width: 200px; max-width: 200px"
        >
          <div
            class="mb-1"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Category"][selectedLanguage.key] }}
          </div>
          <multiselect
            v-model="selectedTableCategory"
            class="text-capitalize"
            :options="categoryList"
            track-by="key"
            label="value"
            :multiple="true"
            :searchable="false"
            placeholder="Select Category"
            :showLabels="false"
            :close-on-select="false"
            :allow-empty="true"
          >
            <template #option="{ option }">
              <input
                type="checkbox"
                :value="option"
                v-model="selectedTableCategory"
              />
              <span class="option__title ml-3 text-capitalize">{{
                option.value.replaceAll("_", " ")
              }}</span>
            </template>
          </multiselect>
        </div>
        <div
          class="customMultiselectCommon"
          style="min-width: 200px; max-width: 200px"
        >
          <div
            class="mb-1"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Sub Category"][selectedLanguage.key] }}
          </div>
          <multiselect
            v-model="selectedTableSubCategory"
            class="text-capitalize"
            :options="subCategoryList"
            track-by="key"
            label="value"
            :multiple="false"
            :searchable="false"
            placeholder="Select Sub Category"
            :showLabels="false"
            :close-on-select="true"
            :allow-empty="true"
            @input="handleCategory"
          >
            <!-- <template #option="{ option }">
              <input
                type="checkbox"
                :value="option"
                v-model="selectedTableSubCategory"
              />
              <span class="option__title ml-3 text-capitalize">{{
                option.value.replaceAll("_", " ")
              }}</span>
            </template> -->
          </multiselect>
        </div>
        <div
          class="customMultiselectCommon"
          v-if="!productCompare"
          style="width: 150px"
        >
          <div class="mb-1 ml-1 label">
            {{ translatedLang["Brand"][selectedLanguage.key] }}
          </div>
          <!-- <select v-model="selectedGlobalBrand" class="form-control text-capitalize platform-select">
                        <option v-for="brand of allBrands[selectedPlatform.platform_id]" :key="brand.id"
                            :value="brand" class="text-capitalize">
                            {{ brand.label.replaceAll("_", " ") }}
                        </option>
                    </select> -->
          <multiselect
            v-model="selectedGlobalBrand"
            :options="allBrands[selectedPlatform.platform_id] || []"
            :multiple="false"
            :searchable="false"
            placeholder="Select Brand"
            label="label"
            track-by="id"
            :showLabels="false"
            :close-on-select="true"
            class="text-capitalize"
            :allow-empty="false"
          >
            <!-- <template #option="{ option }">
                                    <div class="custom-option text-capitalize">
                                        {{ option }}
                                    </div>
                                </template> -->
          </multiselect>
        </div>
        <div
          v-if="!productCompare"
          class="customMultiselectCommon"
          style="min-width: 200px; max-width: 200px"
        >
          <div class="mb-1 ml-1 label">
            {{ translatedLang["Product"][selectedLanguage.key] }}
          </div>
          <multiselect
            v-model="selectedProduct"
            limit="1"
            :options="productList"
            :multiple="true"
            :searchable="true"
            placeholder="Select Product"
            :close-on-select="false"
            :allow-empty="true"
            :showLabels="false"
            track-by="key"
            label="value"
          >
            <template #option="{ option }">
              <div>
                <input
                  type="checkbox"
                  :value="option"
                  v-model="selectedProduct"
                />
                <span class="option__title ml-3">{{ option.value }}</span>
              </div>
            </template>
          </multiselect>
        </div>
        <div
          class="d-flex flex-row align-items-center gap"
          style="margin-top: 20px"
        >
          <!-- Filter and Download Buttons -->
          <button class="btn primarycolor" @click="applyFilters">
            {{ translatedLang["Apply Filters"][selectedLanguage.key] }}
          </button>
          <button
            class="btn navigation-btn"
            v-if="productCompare"
            @click="backToTopPerformance"
          >
            {{ translatedLang["Back"][selectedLanguage.key] }}
          </button>
          <!-- <button
            class="btn navigation-btn"
            v-if="productCompare"
            @click="goToProductSentiments"
          >
            {{ translatedLang["Show Sentiments"][selectedLanguage.key] }}
          </button> -->
        </div>
      </div>
      <div class="tw-flex tw-gap-4 tw-items-center">
        <button
          v-if="!productCompare"
          class="btn primarycolor tw-cursor-pointer tw-bg-[#fff] tw-text-primary_brand tw-border tw-border-[#065559]"
          @click="setProductComparison"
        >
          {{ translatedLang["Compare"][selectedLanguage.key] }}
        </button>
        <button @click="downloadReviews" class="btn navigation-btn">
          {{ translatedLang["Export"][selectedLanguage.key] }}
        </button>
      </div>
    </div>
    <div class="card" v-if="productCompare">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex justify-content-start mt-2" v-if="selectedView">
          <div class="graphHeading pb-2 mr-3">{{ selectedView.view_name }}</div>
          <div class="cursor-pointer" @click="openViewModal('Edit View')">
            <img
              src="../../../public/Icons_SVG/editBtn.svg"
              style="width: 15px; height: 15px"
            />
          </div>
          <div class="cursor-pointer ml-3" @click="showDeleteModal = true">
            <img
              src="../../../public/Icons_SVG/deleteBtnSvg.svg"
              style="width: 15px; height: 15px"
            />
          </div>
        </div>
        <div class="grayedHeading mt-2" v-else>
          {{ translatedLang["Unsaved View"][selectedLanguage.key] }}
        </div>
        <div class="d-flex justify-content-end align-items-end">
          <div style="margin-inline: 0.5rem">
            <div
              class="mb-1 ml-1"
              style="font-size: 14px; font-weight: 400; color: #1e1e1e"
            >
              {{ translatedLang["Select View Name"][selectedLanguage.key] }}
            </div>
            <div
              class="customMultiselect"
              style="width: 250px; margin-bottom: -5px"
            >
              <multiselect
                v-model="selectedView"
                :options="viewOptions"
                :multiple="false"
                :searchable="false"
                placeholder="Select View"
                label="view_name"
                track-by="view_id"
                :showLabels="false"
                :close-on-select="true"
                :allow-empty="false"
                @input="getSelectedSavedView"
              >
              </multiselect>
            </div>
          </div>
          <div class="d-flex align-items-end">
            <button
              @click="resetSavedView"
              class="btn primarycolor mr-2 d-flex item-items-center"
            >
              <span class="newComparisonIcon">
                <svg
                  focusable="false"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                  ></path>
                </svg>
              </span>
              <span>{{
                translatedLang["Add New View"][selectedLanguage.key]
              }}</span>
            </button>
          </div>
          <div class="d-flex justify-content-end align-items-center">
            <button
              class="btn navigation-btn"
              @click="openViewModal('Save View')"
            >
              <span>{{
                translatedLang["Save View"][selectedLanguage.key]
              }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!productCompare" class="card tw-mx-2">
      <div class="heading tw-flex tw-justify-between tw-items-center tw-align-center">
        <p class="">Rating count - Product</p>
        <button class="btn primarycolor" @click="handleExportTable">
          {{ translatedLang["Export"][selectedLanguage.key] }}
        </button>
      </div>
      <div v-if="ratingCountTableShow" class="summaryContainer tw-mt-4">
        <table
          id="rating-table"
          :key="ratingCountList.length"
          class="tw-w-full"
        >
          <thead class="thead-normal">
            <tr>
              <th rowspan="2">Model</th>
              <th
                :colspan="header.subData"
                v-for="header in ratingCountList.header"
                v-if="header.key !== 'model'"
                :key="header.key"
              >
                {{ header.value }}
              </th>
            </tr>
            <tr>
              <template
                v-for="header in ratingCountList.header"
                v-if="header.key !== 'model'"
              >
                <th
                  v-for="star in [
                    { key: '1 star', value: '1' },
                    { key: '2 star', value: '2' },
                    { key: '3 star', value: '3' },
                    { key: '4 star', value: '4' },
                    { key: '5 star', value: '5' },
                  ]"
                  :key="header.key"
                >
                  <div
                    class="tw-flex tw-items-center tw-gap-2 tw-justify-center"
                  >
                    {{ star.value
                    }}<img src="Icons_SVG/rating_star.svg" alt="star" />
                  </div>
                </th>
              </template>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, rowIndex) in ratingCountList.data"
              :key="row.model + '|' + rowIndex"
              class="tw-border tw-border-[#d4d4d4] tw-capitalize"
            >
              <td>{{ row.model }}</td>
              <template
                v-for="header in ratingCountList.header"
                v-if="header.key !== 'model'"
              >
                <td
                  v-for="star in [
                    '1 star',
                    '2 star',
                    '3 star',
                    '4 star',
                    '5 star',
                  ]"
                  :key="header.key + '-' + star"
                >
                  {{
                    row[header.key] && row[header.key][star]
                      ? row[header.key][star]
                      : 0
                  }}
                </td>
              </template>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        v-else-if="!ratingCountTableShow && ratingTableloader"
        class="onLoadingData mt-0"
      >
        {{ translatedLang["Loading"][selectedLanguage.key] }}...
      </div>
      <div
        v-else
        class="text-danger d-flex justify-content-center border border-danger rounded p-2 noData"
      >
        {{ translatedLang["No Data Available"][selectedLanguage.key] }}.
      </div>
    </div>
    <div>
      <div class="mx-2 position-relative" v-if="!productCompare">
        <div class="card">
          <ul class="tabs">
            <li
              v-for="tab of tabs"
              :key="tab"
              @click="switchTab(tab)"
              :class="{ active: tab === selectedTab }"
            >
              {{ translatedLang[tab][selectedLanguage.key] }}
            </li>
          </ul>
          <b-row v-if="topProducts.length && topProductsDataShow">
            <b-col
              v-for="product of topProducts"
              :key="product.product_name"
              class="mt-4"
            >
              <div class="product-section-card">
                <LogoContainer
                  :imgSrc="product.product_image"
                  :placeholder="product.product_image ? false : true"
                  :imageHeight="170"
                />
                <div
                  class="px-3 py-2 mt-3 d-flex flex-column align-items-between"
                >
                  <a
                    :href="product.product_link"
                    target="_blank"
                    class="multiline-ellipsis"
                    :title="product.product_name"
                    >{{ product.product_name }}</a
                  >
                  <!-- On Platform Rating section -->
                  <div
                    style="
                      display: flex;
                      flex-direction: column;
                      flex-grow: 1;
                      justify-content: end;
                      position: relative;
                    "
                  >
                    <p
                      class="mb-0 mt-2"
                      style="font-size: 14px; color: #5e5e5e"
                    >
                      {{ translatedLang["On Platform"][selectedLanguage.key] }}
                    </p>
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <div>
                        <span
                          style="
                            font-size: 14px;
                            color: #065559;
                            font-weight: 600;
                          "
                          >{{ Number(product.platform_rating) }}</span
                        >
                        <span
                          style="
                            font-size: 14px;
                            color: #0655598d;
                            font-weight: 600;
                          "
                        >
                          /5</span
                        >
                        <div class="star-tooltip">
                          <div class="container">
                            <div class="d-inline-flex">
                              <IconStar
                                v-for="i in maxRating"
                                :key="i"
                                class="star"
                              />
                            </div>
                            <div
                              class="overlay"
                              :style="{
                                width: `${
                                  100 - percentage(product.platform_rating)
                                }%`,
                              }"
                            />
                          </div>
                          <div class="star-tooltiptext">
                            <div
                              v-for="(val, key, index) of product
                                .ratings_breakdown.platform"
                              class="rating-row"
                              :key="key"
                            >
                              <div
                                style="width: 10%"
                                class="d-inline-flex align-items-center justify-content-between"
                              >
                                <span class="mr-1">{{
                                  key.split(" ")[0]
                                }}</span>
                                <IconStar class="star text-center" />
                              </div>
                              <span class="ratings-group">
                                <span class="inactive-ratings-bar"></span>
                                <span
                                  class="active-ratings-bar"
                                  :style="{
                                    width: `${val.percent}%`,
                                    'background-color': `${barColors[index]}`,
                                  }"
                                ></span>
                              </span>
                              <div style="color: #5e5e5e; width: 35%">
                                {{ val.count }} ({{ val.percent }}%)
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style="
                          font-size: 14px;
                          color: #5e5e5e;
                          font-weight: 600;
                        "
                      >
                        {{ product.platform_rating_count }}
                        {{
                          product.platform_rating_count !== "NA"
                            ? "Reviews"
                            : ""
                        }}
                      </div>
                    </div>
                  </div>
                  <!-- On Weavr Rating section -->
                  <div
                    style="
                      display: flex;
                      flex-direction: column;
                      flex-grow: 1;
                      justify-content: end;
                      position: relative;
                    "
                  >
                    <p
                      class="mb-0 mt-2"
                      style="font-size: 14px; color: #5e5e5e"
                    >
                      {{ translatedLang["On Weavr"][selectedLanguage.key] }}
                    </p>
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <div>
                        <span
                          style="
                            font-size: 14px;
                            color: #065559;
                            font-weight: 600;
                          "
                          >{{ product.rating.toFixed(1) }}</span
                        >
                        <span
                          style="
                            font-size: 14px;
                            color: #0655598d;
                            font-weight: 600;
                          "
                        >
                          /5</span
                        >
                        <div class="star-tooltip">
                          <div class="container">
                            <div class="d-inline-flex">
                              <IconStar
                                v-for="i in maxRating"
                                :key="i"
                                class="star"
                              />
                            </div>
                            <div
                              class="overlay"
                              :style="{
                                width: `${100 - percentage(product.rating)}%`,
                              }"
                            />
                          </div>
                          <div class="star-tooltiptext">
                            <div
                              v-for="(val, key, index) of product
                                .ratings_breakdown.weavr"
                              class="rating-row"
                              :key="key"
                            >
                              <div
                                style="width: 10%"
                                class="d-inline-flex align-items-center justify-content-between"
                              >
                                <span class="mr-1">{{
                                  key.split(" ")[0]
                                }}</span>
                                <IconStar class="star text-center" />
                              </div>
                              <span class="ratings-group">
                                <span class="inactive-ratings-bar"></span>
                                <span
                                  class="active-ratings-bar"
                                  :style="{
                                    width: `${val.percent}%`,
                                    'background-color': `${barColors[index]}`,
                                  }"
                                ></span>
                              </span>
                              <div style="color: #5e5e5e; width: 35%">
                                {{ val.count }} ({{ val.percent }}%)
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style="
                          font-size: 14px;
                          color: #5e5e5e;
                          font-weight: 600;
                        "
                      >
                        {{ product.rating_count }}
                        {{ translatedLang["Reviews"][selectedLanguage.key] }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row
            v-else-if="!topProductsDataShow && topProductsLoaderForTabs"
            class="onLoadingData mt-3 mx-1"
            >{{ translatedLang["Loading"][selectedLanguage.key] }}...</b-row
          >
          <b-row v-else class="noData mt-3 mx-1">{{
            translatedLang["No Data"][selectedLanguage.key]
          }}</b-row>
        </div>

        <!-- Product Selection Filter -->
        <div
          class="card mt-3 d-flex flex-row gap"
          style="z-index: 9 !important"
        >
          <div style="width: 20%">
            <div class="mb-1 ml-1 label">
              {{ translatedLang["Product"][selectedLanguage.key] }}
            </div>
            <Treeselect
              class="text-capitalize"
              v-model="selectedGlobalProduct"
              :options="categoryWiseProducts[selectedPlatform.platform_id]"
              placeholder="Select Product"
              :show-count="true"
              :multiple="false"
              :clearable="false"
              :disableBranchNodes="true"
              :searchable="true"
              openDirection="top"
            >
              <span slot="noResult">{{
                translatedLang["No elements found"][selectedLanguage.key]
              }}</span>
              <label
                slot="option-label"
                slot-scope="{ node, labelClassName }"
                :title="node.label"
                :class="{
                  'text-truncate d-flex align-items-center text-capitalize':
                    !node.isBranch,
                  'tree-leaf': node.isBranch,
                }"
                >{{ node.label }}</label
              >
            </Treeselect>
          </div>
          <div
            class="d-flex flex-row align-items-center gap"
            style="margin-top: 20px"
          >
            <!-- Filter and Download Buttons -->
            <button class="btn primarycolor" @click="getSelectedProduct">
              {{ translatedLang["Apply Filters"][selectedLanguage.key] }}
            </button>
          </div>
        </div>

        <!-- Selected Product Analytics -->

        <div class="card" v-if="Object.keys(globalProductReviews).length">
          <b-row no-gutters v-if="Object.keys(globalProductReviews).length">
            <b-col cols="8" class="vertical-divider pr-3">
              <BrandIndicator
                level="product"
                :indicatorName="globalProductName.value"
                :brandIndicators="globalProductMarketShare"
              />
              <div>
                <div class="my-4 d-flex flex-row gap">
                  <!-- Button Groups for date filtering -->
                  <button
                    type="button"
                    v-for="filterState of reviewFilterState"
                    :key="filterState"
                    class="section-button"
                    :class="
                      selectedFilterState === filterState ? 'active-button' : ''
                    "
                    @click="filterCustomDate(filterState)"
                  >
                    {{ translatedLang[filterState][selectedLanguage.key] }}
                  </button>
                </div>
                <b-row class="mt-4" no-gutters>
                  <b-col cols="6" class="pr-3">
                    <div
                      class="section-card"
                      v-if="Object.keys(globalProductReviews.ratings).length"
                    >
                      <ReviewsAndRatings
                        :ratingsData="globalProductReviews.ratings"
                      />
                    </div>
                    <div v-else class="section-card">
                      <p class="heading">
                        {{
                          translatedLang["Overall Rating"][selectedLanguage.key]
                        }}
                      </p>
                      <div class="noData">
                        {{ translatedLang["No Data"][selectedLanguage.key] }}
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="6">
                    <div
                      class="section-card"
                      v-if="
                        Object.keys(globalProductSentiments.sentiment).length
                      "
                    >
                      <Sentiments
                        :sentimentsData="globalProductSentiments.sentiment"
                        :navigation="true"
                        @navigate-to-sentiment-details="
                          navigateWordCloud('sentiments-detail')
                        "
                      />
                    </div>
                    <div v-else>
                      <p class="heading">
                        {{
                          translatedLang["Customer Sentiments"][
                            selectedLanguage.key
                          ]
                        }}
                      </p>
                      <div class="noData">
                        {{ translatedLang["No Data"][selectedLanguage.key] }}
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mt-3"> 
                  <b-col cols="12">
                    <PerformanceChart
                      heading="Brand"
                      :showTabs="true"
                      :performanceData="
                        globalProductReviews.performance_ratings
                      "
                      :performanceRatingsData="performanceRatingsData"
                      :brandPerformanceData="brandPerformanceData"
                      :isProductPage="true"
                    />
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col
              cols="4"
              class="pl-3"
              style="
                background: linear-gradient(
                  180deg,
                  rgba(255, 255, 255, 0) 94.69%,
                  rgba(14, 14, 14, 0.1) 100%
                );
              "
            >
              <LogoContainer
                :brandContainer="true"
                :imgSrc="globalProductImage"
              />
              <div class="mt-2">
                <div class="review-heading">
                  <div id="border"></div>
                  <div id="heading">
                    {{ translatedLang["Review Summary"][selectedLanguage.key] }}
                  </div>
                </div>
                <div class="section-card my-3 px-4 py-3">
                  <div
                    style="font-size: 15px; font-weight: 600; letter-spacing: 0"
                  >
                    {{
                      translatedLang["What customers say"][
                        selectedLanguage.key
                      ]
                    }}:
                  </div>
                  <div class="py-2">
                    {{ globalProductAISummary }}
                  </div>
                  <div style="font-family: Heebo; color: #5e5e5e" class="pb-2">
                    {{
                      translatedLang[
                        "AI-generated from the text of customer reviews"
                      ][selectedLanguage.key]
                    }}
                  </div>
                </div>
              </div>
              <LatestReviews
                :latestReviews="globalProductReviews.reviews"
                parentClasses="mt-2"
              />
            </b-col>
          </b-row>
          <!-- <section id="sentiments-detail" class="mt-3">
            <b-row
              no-gutters
              v-if="Object.keys(globalProductSentiments.word_clowd).length"
            >
              <b-col cols="6" class="pr-2">
                <div
                  class="section-card"
                  v-if="Object.keys(globalProductSentiments.word_clowd).length"
                >
                  <div
                    class="d-flex justify-content-between align-items-center heading"
                  >
                    <p class="mb-0">
                      {{
                        translatedLang["Positive Sentiments"][
                          selectedLanguage.key
                        ]
                      }}
                    </p>
                    <div class="customSelect">
                      <select
                        class="form-control text-capitalize platform-select"
                        v-model="selectedPositiveCloudLimit"
                      >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                      </select>
                    </div>
                  </div>
                  <div
                    v-if="globalProductSentiments.word_clowd.positive.length"
                  >
                    <WordCloud
                      :cloudData="
                        globalProductSentiments.word_clowd.positive.slice(
                          0,
                          selectedPositiveCloudLimit
                        )
                      "
                      color="#065559"
                      @analyse-keyword="openPositiveModal"
                    />
                  </div>
                  <div v-else class="noData">
                    {{ translatedLang["No Data"][selectedLanguage.key] }}
                  </div>
                </div>
              </b-col>
              <b-col cols="6" class="pl-1">
                <div
                  class="section-card"
                  v-if="Object.keys(globalProductSentiments.word_clowd).length"
                >
                  <div
                    class="d-flex justify-content-between align-items-center heading"
                  >
                    <p class="mb-0">
                      {{
                        translatedLang["Negative Sentiments"][
                          selectedLanguage.key
                        ]
                      }}
                    </p>
                    <div class="customSelect">
                      <select
                        class="form-control text-capitalize platform-select"
                        v-model="selectedNegativeCloudLimit"
                      >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                      </select>
                    </div>
                  </div>

                  <div
                    v-if="globalProductSentiments.word_clowd.negative.length"
                  >
                    <WordCloud
                      :cloudData="
                        globalProductSentiments.word_clowd.negative.slice(
                          0,
                          selectedNegativeCloudLimit
                        )
                      "
                      color="#FD5542"
                      @analyse-keyword="openNegativeModal"
                    />
                  </div>
                  <div v-else class="noData">
                    {{ translatedLang["No Data"][selectedLanguage.key] }}
                  </div>
                </div>
              </b-col>
            </b-row>
          </section> -->
          <!-- <b-row no-gutters v-if="Object.keys(globalProductSentiments).length">
            <b-col cols="8" class="pb-4 pr-2">
              <div class="section-card mt-3">
                <p class="heading">
                  {{ translatedLang["All Sentiments"][selectedLanguage.key] }}
                </p>
                <div class="thin-scroller">
                  <table
                    class="w-100 mt-4"
                    id="product-sentiments-table"
                    v-if="globalProductSentiments.table.length"
                  >
                    <thead>
                      <tr>
                        <th>
                          {{ translatedLang["Keyword"][selectedLanguage.key] }}
                        </th>
                        <th>
                          {{
                            translatedLang["Frequency"][selectedLanguage.key]
                          }}
                        </th>
                        <th>
                          {{ translatedLang["Score"][selectedLanguage.key] }}
                        </th>
                        <th>
                          {{
                            translatedLang["Total Frequency"][
                              selectedLanguage.key
                            ]
                          }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(row, index) of globalProductSentiments.table"
                        :data-row-index="index"
                      >
                        <td
                          class="keyword"
                          role="button"
                          tabindex="0"
                          @click="openModal(row.word_new)"
                        >
                          {{ row.word_new.value }}
                        </td>
                        <td class="text-center">
                          <div
                            style="
                              font-family: Heebo;
                              font-size: 16px;
                              font-weight: 400;
                              color: #065559;
                            "
                          >
                            {{ formatNumber(row.positive_frequency) }}
                          </div>
                          <div
                            style="
                              font-family: Heebo;
                              font-size: 16px;
                              font-weight: 400;
                              color: #d90000;
                            "
                          >
                            {{ formatNumber(row.negative_frequency) }}
                          </div>
                        </td>
                        <td class="text-center">
                          <div
                            class="d-flex justify-content-center align-items-center gauge-container"
                          >
                            <GaugeChart :rawData="row" />
                          </div>
                        </td>
                        <td>
                          {{ row.positive_frequency + row.negative_frequency }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div v-else class="noData">
                    {{ translatedLang["No Data"][selectedLanguage.key] }}
                  </div>
                </div>
              </div>
            </b-col>
            <b-col cols="4" class="pl-1">
              <div class="section-card my-3" style="height: 1000px">
                <p class="heading">
                  {{ translatedLang["Insights"][selectedLanguage.key] }}
                </p>
                <div
                  style="height: 1000px; overflow-y: auto"
                  class="thin-scrollerBar pr-1 pt-1"
                >
                  <div
                    class="inSightsContainer d-flex"
                    v-for="(insight, index) in viewMostReviewsInsightsData"
                    :key="'most' + index"
                  >
                    <div
                      class="col-1 d-flex justify-content-center align-items-center flex-column"
                    >
                      <p
                        class="mb-0 px-2"
                        style="color: #00555a; font-weight: 400"
                      >
                        {{
                          new Date(dateRange.endDate).toLocaleString("en-US", {
                            month: "short",
                          })
                        }}
                      </p>
                      <p
                        class="mb-0 px-2"
                        style="
                          font-size: 20px;
                          font-weight: 600;
                          color: #5e5e5e;
                        "
                      >
                        {{ new Date(dateRange.endDate).getDate() }}
                      </p>
                    </div>
                    <div class="col-11 pt-2 pb-2">
                      <p class="insightsContent mb-2" v-html="insight"></p>
                    </div>
                  </div> -->
                  <!-- <div class="inSightsContainer d-flex mt-3"
                                        v-for="(insight, index) in viewWorstReviewsInsightsData" :key="'worst' + index">
                                        <div class="col-1 d-flex justify-content-center align-items-center flex-column">
                                            <p class="mb-0 px-2" style="color: #00555A; font-weight: 400;">{{ new
                                                Date(dateRange.endDate).toLocaleString('en-US', {
                                                    month: 'short'
                                                }) }}
                                            </p>
                                            <p class="mb-0 px-2"
                                                style="font-size: 20px;font-weight: 600; color: #5E5E5E;">{{
                                                    new Date(dateRange.endDate).getDate() }}</p>
                                        </div>
                                        <div class="col-11 pt-2 pb-2">
                                            <p class="insightsContent mb-2" v-html="insight"></p>
                                        </div>
                                    </div> -->
                  <!-- <div
                    class="inSightsContainer d-flex mt-3"
                    v-for="(insight, index) in viewKeywordInsightsData"
                    :key="'keyword' + index"
                  >
                    <div
                      class="col-1 d-flex justify-content-center align-items-center flex-column"
                    >
                      <p
                        class="mb-0 px-2"
                        style="color: #00555a; font-weight: 400"
                      >
                        {{
                          new Date(dateRange.endDate).toLocaleString("en-US", {
                            month: "short",
                          })
                        }}
                      </p>
                      <p
                        class="mb-0 px-2"
                        style="
                          font-size: 20px;
                          font-weight: 600;
                          color: #5e5e5e;
                        "
                      >
                        {{ new Date(dateRange.endDate).getDate() }}
                      </p>
                    </div>
                    <div class="col-11 pt-2 pb-2">
                      <p class="insightsContent mb-2" v-html="insight"></p>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row> -->
        </div>
      </div>
      <div class="ml-1 mr-2" v-else-if="productCompare">
        <b-row no-gutters class="mb-4">
          <b-col cols="4">
            <div>
              <div class="compare-card">
                <b-row>
                  <b-col>
                    <LogoContainer
                      :imgSrc="comparisonList[0].img"
                      :placeholder="comparisonList[0].img ? false : true"
                      :imageHeight="170"
                    />
                  </b-col>
                  <b-col
                    class="px-2 d-flex flex-column justify-content-between"
                    style="gap: 8px"
                  >
                    <div class="mb-4 mt-2" style="font-size: 16px">
                      <!-- <span
                        class="font-weight-bold text-capitalize"
                        style="color: #065559"
                        >{{ selectedCategory.value }}:
                      </span> -->
                      <span class="text-capitalize tw-text-[#065559]">{{
                        selectedCompBrand1.label
                      }}</span>
                      <div class="mt-2" style="color: #5e5e5e">
                        {{
                          comparisonList[0] &&
                          Array.isArray(comparisonList[0].selectedProduct) &&
                          comparisonList[0].selectedProduct.length &&
                          typeof comparisonList[0].selectedProduct[0] ===
                            "string" &&
                          comparisonList[0].selectedProduct[0].split("+")[0] ===
                            client
                            ? "Primary Product"
                            : "Competitor Product"
                        }}
                      </div>
                    </div>
                    <div style="width: 95%">
                      <div class="customMultiselectCommon">
                        <multiselect
                          v-model="selectedCompBrand1"
                          :options="
                            allBrands[selectedPlatform.platform_id] || []
                          "
                          :multiple="false"
                          :searchable="false"
                          placeholder="Select Brand"
                          label="label"
                          track-by="id"
                          :showLabels="false"
                          :close-on-select="true"
                          class="text-capitalize"
                          :allow-empty="false"
                        >
                        </multiselect>
                      </div>
                      <Treeselect
                        v-if="allProducts[selectedPlatform.platform_id]?.length"
                        :options="ComProductList"
                        v-model="comparisonList[0].selectedProduct"
                        value-consists-of="LEAF_PRIORITY"
                        :multiple="true"
                        @input="updateComparisonData(0)"
                        :disableBranchNodes="true"
                        placeholder="Select Product"
                        limit="0"
                      >
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.label }}
                        </div>
                      </Treeselect>
                    </div>
                  </b-col>
                </b-row>
                <div class="px-2">
                  <ReviewsAndRatings
                    v-if="
                      Object.keys(comparisonList[0]?.ratingsData).length &&
                      comparisonList[0].selectedProduct.length <= 1
                    "
                    :ratingsData="comparisonList[0]?.ratingsData"
                  />
                  <div
                    v-if="comparisonList[0].selectedProduct.length > 1"
                    class="tw-border-[1px] tw-border-[#D4D4D4] tw-rounded-[5px] tw-p-4 tw-m-2"
                  >
                    <p class="heading tw-pb-4 tw-m-0 tw-p-0">
                      Rating VS Model {{ selectedCompBrand1.label }}
                    </p>
                    <dynamicChart
                      :data="comparisonList[0].barGraphData"
                      :isLegend="true"
                      :height="400"
                      :key="comparisonList[0].barGraphData?.seriesData?.length"
                    />
                  </div>
                </div>
                <div id="reviewLineChart"
                  class="tw-border-[1px] tw-border-[#D4D4D4] tw-rounded-[5px] tw-p-4 tw-m-4"
                  v-if="
                    (comparisonList[0] && comparisonList[0].trendlineData) ||
                    (comparisonList[0] && comparisonList[0].multiTrendLineData)
                  "
                >
                  <div v-if="comparisonList[0].selectedProduct.length <= 1" >
                    <div
                      class="heading tw-p-0 tw-m-0 tw-pb-4 tw-flex tw-justify-between tw-items-center"
                    >
                      <p class="tw-mb-0 tw-pb-0">Rating Performance</p>
                      <b-button-toolbar aria-label="Toolbar with buttons group">
                        <b-form-radio-group
                          class="mr-3 radiohide"
                          id="radiosBtn"
                          buttons
                          button-variant="outline-secondary"
                          v-model="reviewLineChartInterval"
                          name="radiosBtn"
                        >
                          <b-form-radio class="mx-0" value="week_on_week">{{
                            translatedLang["Week"][selectedLanguage.key]
                          }}</b-form-radio>
                          <b-form-radio class="mx-0" value="month_on_month">{{
                            translatedLang["Month"][selectedLanguage.key]
                          }}</b-form-radio>
                        </b-form-radio-group>
                      </b-button-toolbar>
                    </div>
                    <lineChart
                      :data="comparisonList[0].trendlineData"
                      :key="Date.now() + 'data'"
                    />
                  </div>
                  <div v-else>
                    <p class="heading tw-m-0 tw-p-0 tw-pb-4">Review vs Model</p>

                    <lineChart
                      :data="comparisonList[0].multiTrendLineData"
                      :key="Date.now() + 'data'"
                    />
                  </div>
                </div>
              </div>
            </div>
          </b-col>
          <b-col cols="8">
            <div
              class="d-flex w-100 px-1 thin-scroller"
              style="overflow-x: auto; min-height: 100%"
            >
              <div
                v-for="index in 5"
                class="mx-1"
                :id="'compare-card-' + index"
                style="min-width: 50%"
                v-if="comparisonList[index]"
              >
                <div class="compare-card">
                  <b-row>
                    <b-col>
                      <LogoContainer
                        :imgSrc="comparisonList[index].img"
                        :placeholder="comparisonList[index].img ? false : true"
                        :imageHeight="170"
                      />
                    </b-col>
                    <b-col
                      class="px-2 d-flex flex-column justify-content-between position-relative"
                      style="gap: 8px"
                    >
                      <div class="mb-4 mt-2" style="font-size: 16px">
                        <!-- <span
                          class="font-weight-bold text-capitalize"
                          style="color: #065559"
                          >{{ selectedCategory.value }}:
                        </span> -->
                        <span class="text-capitalize tw-text-[#065559]">{{
                          selectedCompBrand.label
                        }}</span>
                        <div class="mt-2" style="color: #5e5e5e">
                          {{
                            comparisonList[index] &&
                            Array.isArray(
                              comparisonList[index].selectedProduct
                            ) &&
                            comparisonList[index].selectedProduct.length &&
                            typeof comparisonList[index].selectedProduct[0] ===
                              "string" &&
                            comparisonList[index].selectedProduct[0].split(
                              "+"
                            )[0] === client
                              ? "Primary Product"
                              : "Competitor Product"
                          }}
                        </div>
                      </div>
                      <div style="width: 95%">
                        <div class="customMultiselectCommon">
                          <multiselect
                            v-model="selectedCompBrand"
                            :options="
                              allBrands[selectedPlatform.platform_id] || []
                            "
                            :multiple="false"
                            :searchable="false"
                            placeholder="Select Brand"
                            label="label"
                            track-by="id"
                            :showLabels="false"
                            :close-on-select="true"
                            class="text-capitalize"
                            :allow-empty="false"
                          >
                          </multiselect>
                        </div>
                        <Treeselect
                          v-if="
                            allProducts[selectedPlatform.platform_id]?.length
                          "
                          :options="ComProductList1"
                          v-model="comparisonList[index].selectedProduct"
                          value-consists-of="LEAF_PRIORITY"
                          :multiple="true"
                          placeholder="Select Product"
                          @input="updateComparisonData(index)"
                          :disableBranchNodes="true"
                          limit="0"
                        >
                          <div slot="value-label" slot-scope="{ node }">
                            {{ node.label }}
                          </div>
                        </Treeselect>
                        <!-- <Treeselect
                          append-to-body
                          v-if="
                            allProducts[selectedPlatform.platform_id]?.length
                          "
                          class="text-capitalize"
                          v-model="comparisonList[index].selectedProduct"
                          :options="ComProductList1"
                          placeholder="Select Product"
                          :show-count="true"
                          :multiple="false"
                          @input="updateComparisonData(index)"
                          :clearable="false"
                          :disableBranchNodes="true"
                          :searchable="true"
                        >
                          <span slot="noResult">{{
                            translatedLang["No elements found"][
                              selectedLanguage.key
                            ]
                          }}</span>
                          <label
                            slot="option-label"
                            slot-scope="{ node, labelClassName }"
                            :title="node.label"
                            :class="{
                              'text-truncate d-flex align-items-center text-capitalize':
                                !node.isBranch,
                              'tree-leaf': node.isBranch,
                            }"
                            >{{ node.label }}</label
                          >
                        </Treeselect> -->
                      </div>
                      <div class="close-card" @click="removeCompareCard(index)">
                        <i class="fa fa-close"></i>
                      </div>
                    </b-col>
                  </b-row>
                  <div class="px-2">
                    <ReviewsAndRatings
                      v-if="
                        Object.keys(comparisonList[index].ratingsData).length &&
                        comparisonList[index].selectedProduct.length <= 1
                      "
                      :ratingsData="comparisonList[index].ratingsData"
                    />
                    <div
                      v-if="comparisonList[index].selectedProduct.length > 1"
                      class="tw-border-[1px] tw-border-[#D4D4D4] tw-rounded-[5px] tw-p-4 tw-m-2"
                    >
                      <p class="heading tw-pb-4 tw-m-0 tw-p-0">
                        Rating VS Model {{ selectedCompBrand.label }}
                      </p>
                      <dynamicChart
                        :data="comparisonList[index].barGraphData"
                        :isLegend="true"
                        :height="400"
                        :key="
                          comparisonList[index].barGraphData?.seriesData?.length
                        "
                      />
                    </div>
                  </div>
                  <div id="reviewLineChart"
                    class="tw-border-[1px] tw-border-[#D4D4D4] tw-rounded-[5px] tw-p-4 tw-m-4"
                    v-if="
                      (comparisonList[index] &&
                        comparisonList[index].trendlineData) ||
                      (comparisonList[index] &&
                        comparisonList[index].multiTrendLineData)
                    "
                  >
                    <div
                      v-if="comparisonList[index].selectedProduct.length <= 1"
                    >
                      <div
                        class="heading tw-p-0 tw-m-0 tw-pb-4 tw-flex tw-justify-between tw-items-center"
                      >
                        <p class="tw-mb-0 tw-pb-0">Rating Performance</p>
                        <b-button-toolbar
                          aria-label="Toolbar with buttons group"
                        >
                          <b-form-radio-group
                            class="mr-3 radiohide"
                            id="radiosBtn"
                            buttons
                            button-variant="outline-secondary"
                            v-model="reviewLineChartInterval"
                            name="radiosBtn"
                          >
                            <b-form-radio class="mx-0" value="week_on_week">{{
                              translatedLang["Week"][selectedLanguage.key]
                            }}</b-form-radio>
                            <b-form-radio class="mx-0" value="month_on_month">{{
                              translatedLang["Month"][selectedLanguage.key]
                            }}</b-form-radio>
                          </b-form-radio-group>
                        </b-button-toolbar>
                      </div>
                      <lineChart
                        :data="comparisonList[index].trendlineData"
                        :key="Date.now() + 'data'"
                      />
                    </div>
                    <div v-else>
                      <p class="heading tw-m-0 tw-p-0 tw-pb-4">
                        Review vs Model
                      </p>

                      <lineChart
                        :data="comparisonList[index].multiTrendLineData"
                        :key="Date.now() + 'data'"
                      />
                    </div>
                  </div>
                </div>
                <!-- <div
                  class="compare-card my-3 px-2 py-3"
                  v-if="Object.keys(comparisonList[index].sentiments).length"
                >
                  <Sentiments
                    :sentimentsData="comparisonList[index].sentiments.sentiment"
                    :navigation="true"
                    @navigate-to-sentiment-details="
                      navigateWordCloud(`word-cloud-${index}`)
                    "
                  />
                </div> -->
                <!-- <div
                  :id="'word-cloud-' + index"
                  class="compare-card my-3 px-2 py-3"
                  v-if="Object.keys(comparisonList[index].sentiments).length"
                >
                  <div>
                    <p class="heading">
                      {{
                        translatedLang["Positive Sentiments"][
                          selectedLanguage.key
                        ]
                      }}
                    </p>
                    <WordCloud
                      v-if="
                        comparisonList[index].sentiments.word_clowd.positive
                          .length
                      "
                      :cloudData="
                        comparisonList[index].sentiments.word_clowd.positive
                      "
                      color="#065559"
                    />
                    <div v-else style="height: 350px">
                      <div class="px-4 py-2" style="color: var(--red-80)">
                        {{ translatedLang["No Data"][selectedLanguage.key] }}
                      </div>
                    </div>
                  </div>
                </div> -->
                <!-- <div
                  class="compare-card mt-3 px-2 py-3"
                  v-if="Object.keys(comparisonList[index].sentiments).length"
                >
                  <div>
                    <p class="heading">
                      {{
                        translatedLang["Negative Sentiments"][
                          selectedLanguage.key
                        ]
                      }}
                    </p>
                    <WordCloud
                      v-if="
                        comparisonList[index].sentiments.word_clowd.negative
                          .length
                      "
                      :cloudData="
                        comparisonList[index].sentiments.word_clowd.negative
                      "
                      color="#FD5542"
                    />
                    <div v-else style="height: 350px">
                      <div class="px-4 py-2" style="color: var(--red-80)">
                        {{ translatedLang["No Data"][selectedLanguage.key] }}
                      </div>
                    </div>
                  </div>
                </div> -->
              </div>
              <div
                v-if="comparisonList.length < 5"
                class="d-flex"
                :style="
                  comparisonList.length < 2
                    ? 'min-width: 90%;'
                    : 'min-width: 45%;'
                "
              >
                <div class="add-comparison mx-1 w-100">
                  <div class="plus-icon" @click="prepareComparisonList">+</div>
                  <div style="font-size: 16px; font-weight: 500">
                    {{ translatedLang["Add Product"][selectedLanguage.key] }}
                  </div>
                </div>
                <div
                  class="add-comparison"
                  v-if="comparisonList.length < 2"
                  :style="
                    comparisonList.length === 2
                      ? 'min-width: 50%'
                      : 'min-width: 45%'
                  "
                >
                  <div class="plus-icon" @click="prepareComparisonList">+</div>
                  <div style="font-size: 16px; font-weight: 500">
                    {{ translatedLang["Add Product"][selectedLanguage.key] }}
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>

        <!-- <div class="mx-2 card" v-if="Object.keys(reviewCountChart).length">
          <div
            class="d-flex justify-content-between align-items-center card-heading"
          >
            <p>
              {{ translatedLang["Number of Reviews"][selectedLanguage.key] }}
            </p>
            <b-button-toolbar aria-label="Toolbar with buttons group">
              <b-form-radio-group
                class="mr-3 radiohide"
                id="radiosBtn"
                buttons
                button-variant="outline-secondary"
                v-model="reviewCountInterval"
                @change="changeCountInterval"
                name="radiosBtn"
              >
                <b-form-radio class="mx-0" value="day">{{
                  translatedLang["Day"][selectedLanguage.key]
                }}</b-form-radio>
                <b-form-radio class="mx-0" value="week">{{
                  translatedLang["Week"][selectedLanguage.key]
                }}</b-form-radio>
                <b-form-radio class="mx-0" value="month">{{
                  translatedLang["Month"][selectedLanguage.key]
                }}</b-form-radio>
              </b-form-radio-group>
            </b-button-toolbar>
          </div>
          <MultiLineChart
            :rawData="reviewCountChart"
            legendVerticalAlign="bottom"
            legendHorizontalAlign="left"
          />
        </div> -->
        <!-- <div class="mx-2 card" v-if="vocData.length">
          <div
            class="d-flex justify-content-between align-items-center card-heading"
          >
            <p>
              {{ translatedLang["Voice of Customers"][selectedLanguage.key] }}
            </p>
          </div>
          <b-row>
            <b-col
              cols="5"
              v-if="vocPieChart.length"
              style="border-right: 1px solid #d9d9d9"
            >
              <ThinPie
                :rawData="vocPieChart"
                :noTotalText="true"
                innerSize="30%"
                :formatLegend="false"
                :dataLabel="true"
              />
            </b-col>
            <b-col cols="7" v-if="Object.keys(vocStack).length">
              <StackChart :rawData="vocStack" />
            </b-col>
          </b-row>
        </div> -->
      </div>
    </div>
    <b-modal
      v-model="keywordModal"
      size="xl"
      :title="modalTitle"
      @hidden="resetModal"
    >
      <div class="modal-control-panel mt-3">
        <ul>
          <li
            v-for="tab of modalTabs"
            :key="tab"
            @click="selectedModalTab = tab"
            :class="{ 'selected-tab': tab === selectedModalTab }"
          >
            {{ translatedLang[tab][selectedLanguage.key] }}
          </li>
        </ul>
        <div class="d-flex" style="margin-top: -16px">
          <b-button-toolbar
            aria-label="Toolbar with buttons group"
            v-show="
              selectedModalTab === 'Frequency' ||
              selectedModalTab === 'Score' ||
              selectedModalTab === 'Review Count'
            "
          >
            <b-form-radio-group
              class="mr-3 radiohide"
              id="radiosBtn"
              buttons
              button-variant="outline-secondary"
              @change="updateSentimentData"
              v-model="keywordInterval"
              name="radiosBtn"
            >
              <b-form-radio class="mx-0" value="month">{{
                translatedLang["Month"][selectedLanguage.key]
              }}</b-form-radio>
              <b-form-radio class="mx-0" value="week">{{
                translatedLang["Week"][selectedLanguage.key]
              }}</b-form-radio>
            </b-form-radio-group>
          </b-button-toolbar>
          <date-range-picker
            v-model="modalDateRange"
            :show-dropdowns="true"
            opens="right"
            :autoApply="true"
            :locale-data="{ format: 'dd mmm yyyy' }"
            :min-date="minDate"
            :max-date="maxDate"
            :ranges="false"
            @update="updateModal"
          >
          </date-range-picker>
        </div>
      </div>
      <div v-if="Object.keys(keywordWiseSentiments).length">
        <KeywordModalCard
          :selectedTab="selectedModalTab"
          :keywordReview="keywordWiseReviews"
          :keywordSentiment="keywordWiseSentiments"
          :keywordTreeData="keywordTreeData"
          @filter-reviews="filterReviews"
          @toggle-node="toggleTreeNode"
        />
      </div>
      <!-- <div class="modal-control-panel">
                <h6>{{ selectedKeywordChartMetric.label }}</h6>
                <div class="d-flex" style="gap: 6px;">
                    <select class="customselect" v-model="selectedKeywordChartMetric">
                        <option v-for="metric of keywordChartMetric" :key="metric.key" :value="metric">{{
                            metric.label }}</option>
                    </select>
                    <b-button-toolbar aria-label="Toolbar with buttons group">
                        <b-form-radio-group class="mr-3 radiohide" id="radiosBtn" buttons
                            button-variant="outline-secondary" @change="updateSentimentData" v-model="keywordInterval"
                            name="radiosBtn">
                            <b-form-radio class="mx-0" value="month">Month</b-form-radio>
                            <b-form-radio class="mx-0" value="week">Week</b-form-radio>
                        </b-form-radio-group>
                    </b-button-toolbar>
                    <date-range-picker style="width: 200%;" v-model="modalDateRange" :show-dropdowns="true" opens='left'
                        :autoApply="true" :locale-data="{ format: 'dd mmm yyyy' }" :min-date="minDate"
                        :max-date="maxDate" :ranges="false" @update="updateModal">
                    </date-range-picker>
                </div>
            </div>
            <div v-if="Object.keys(keywordWiseSentiments).length">
                <KeywordModalCard :keywordReview="keywordWiseReviews" :keywordSentiment="keywordWiseSentiments"
                    :chartKey="selectedKeywordChartMetric.key" @filter-reviews="filterReviews" />
            </div> -->
    </b-modal>
    <b-modal
      size="md"
      class="customModal"
      hide-footer
      style="z-index: 3000 !important; text-transform: capitalize"
      v-model="showViewModal"
      :title="viewModalName"
    >
      <div class="customMultiselect" v-if="viewModalName === 'Save View'">
        <multiselect
          v-model="selectedModalView"
          :options="modalViewOptions"
          :multiple="false"
          :searchable="false"
          placeholder="Select View"
          label="view_name"
          track-by="view_id"
          :showLabels="false"
          :close-on-select="true"
          :allow-empty="false"
        >
        </multiselect>
      </div>
      <input
        required
        type="text"
        v-model="newViewName"
        class="text-capitalize customInput px-2"
        v-show="
          viewModalName === 'Edit View' ||
          (viewModalName === 'Save View' &&
            selectedModalView.view_id === 'add_new')
        "
      />
      <div class="d-flex justify-content-end align-items-center mt-3">
        <button
          class="btn navigation-btn"
          :disabled="spinLoader"
          @click="saveCompareView"
        >
          <b-spinner small class="mr-2" v-if="spinLoader"></b-spinner>
          <span>{{ translatedLang["Save View"][selectedLanguage.key] }}</span>
        </button>
      </div>
    </b-modal>
    <b-modal
      title="Delete View"
      v-model="showDeleteModal"
      class="container-modal-ASIN"
    >
      <div class="modal-delete-content d-flex align-items-start mb-2">
        <div class="delete-alert text-center rounded-circle px-2 mr-3">
          &#9888;
        </div>
        <div>
          {{
            translatedLang["delete this View"][selectedLanguage.key]
          }}.<br />{{ translatedLang["Are you sure"][selectedLanguage.key] }} ?
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <b-button @click="showDeleteModal = false" class="btn primarycolor"
          >{{ translatedLang["No"][selectedLanguage.key] }},
          {{ translatedLang["Keep It"][selectedLanguage.key] }}.</b-button
        >
        <button
          @click="deleteView"
          :disabled="spinLoader"
          class="btn primarycolor px-3 py-1 ml-2 d-flex align-items-center delete-viewBtn"
          style="background-color: var(--red)"
        >
          <b-spinner small class="mr-2" v-if="spinLoader"></b-spinner>
          <span
            >{{ translatedLang["Yes"][selectedLanguage.key] }},
            {{ translatedLang["Delete"][selectedLanguage.key] }}!</span
          >
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import moment from "moment";
import Multiselect from "vue-multiselect";
import LogoContainer from "./Components/LogoContainer.vue";
import IconStar from "../../assets/IconStar.vue";
import BrandIndicator from "./Components/BrandIndicator.vue";
import ReviewsAndRatings from "./Components/ReviewsAndRatings.vue";
import Sentiments from "./Components/Sentiments.vue";
import PerformanceChart from "./Components/PerformanceChart.vue";
import LatestReviews from "./Components/LatestReviews.vue";
import GaugeChart from "../commonCharts/GaugeChart.vue";
import KeywordModalCard from "./Components/KeywordModalCard.vue";
import WordCloud from "../commonCharts/WordCloud.vue";
import MultiLineChart from "../commonCharts/MultiLineChart.vue";
import ThinPie from "../commonCharts/ThinPie.vue";
import StackChart from "../commonCharts/StackChart.vue";
import Loader from "../Components/Loader.vue";
import Treeselect from "@riophae/vue-treeselect";
import lineChart from "../commonCharts/lineChart.vue";
import dynamicChart from "../commonCharts/Chart/dynamicChart.vue";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapState, mapActions } from "vuex";

export default {
  name: "ProductReviews",
  components: {
    Treeselect,
    Loader,
    Multiselect,
    LogoContainer,
    BrandIndicator,
    LatestReviews,
    PerformanceChart,
    KeywordModalCard,
    GaugeChart,
    IconStar,
    ReviewsAndRatings,
    Sentiments,
    WordCloud,
    MultiLineChart,
    ThinPie,
    StackChart,
    lineChart,
    dynamicChart,
  },
  data() {
    return {
      loader: false,
      reviewLoader: false,
      countLoader: false,
      spinLoader: false,
      savedViewLoader: false,
      vocLoader: false,
      dateRange: {
        startDate: moment().subtract(3, "months").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        // startDate: "2022-04-11",  // Fixed start date
        // endDate: "2023-04-30"
      },
      modalDateRange: {
        startDate: moment().subtract(3, "months").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      maxDate: new Date(),
      minDate: new Date(moment().subtract(3, "years")),
      client: JSON.parse(localStorage.reviewUserData).data.client,
      featureId: JSON.parse(localStorage.reviewUserData).data.feature_id_map.Reviews_And_Ratings,
      platforms: [],
      selectedPlatform: "",
      // selectedProductPlatform: "",
      categories: {},
      selectedCategory: {},
      selectedProductCategory: null,
      tabs: [
        "Top Reviewed",
        "Worst Reviewed",
        "Most Reviewed",
        "Least Reviewed",
      ],
      selectedTab: "Top Reviewed",
      topProducts: [],
      tabKeyMapper: {
        "Most Reviewed": {
          keyVal: "count",
          keyType: "increasing",
        },
        "Least Reviewed": {
          keyVal: "count",
          keyType: "decreasing",
        },
        "Top Reviewed": {
          keyVal: "ratings",
          keyType: "increasing",
        },
        "Worst Reviewed": {
          keyVal: "ratings",
          keyType: "decreasing",
        },
      },
      maxRating: 5,
      productCompare: false,
      availableProducts:
        localStorage.demo_voc_product_list &&
        JSON.parse(localStorage.demo_voc_product_list),
      filteredProducts: [],
      comparisonList: [],
      numberOfReviews: [],
      reviewCountChart: {},
      reviewCountInterval: "week",
      vocData: [],
      vocPieChart: [],
      vocStack: {},
      allProducts: [],
      defaultComparisonProduct: null,
      savedViews: [],
      viewOptions: [],
      selectedView: "",
      showViewModal: false,
      viewModalName: "",
      showDeleteModal: false,
      newViewName: "",
      selectedModalView: {
        view_id: "add_new",
        view_name: "Add New",
      },
      modalViewOptions: [],
      allBrands: {},
      selectedGlobalBrand: {},
      selectedGlobalProduct: null,
      globalProductReviews: {},
      globalProductSentiments: {},
      globalProductAISummary: "",
      globalProductName: "",
      globalProductImage: "",
      globalProductMarketShare: {},
      categoryWiseProducts: {},
      reviewFilterState: ["Overview", "Last Week", "Last Month", "Last Year"],
      selectedFilterState: "Overview",
      keywordModal: false,
      selectedModalKeyword: "",
      modalTitle: "",
      keywordWiseReviews: [],
      keywordWiseSentiments: {},
      keywordTreeData: {},
      modalTabs: [
        "Reviews",
        "Frequency",
        // "Score",
        "Review Count",
        // "Tree Structure",
        "Contribution tree",
      ],
      selectedModalTab: "Reviews",
      keywordInterval: "month",
      selectedPositiveCloudLimit: 10,
      selectedNegativeCloudLimit: 10,
      // product insights
      viewKeywordInsightsData: "",
      viewMostReviewsInsightsData: "",
      viewWorstReviewsInsightsData: "",
      performanceRatingsData: [],
      brandPerformanceData:[],
      brandNameFromLogin: JSON.parse(localStorage.reviewUserData).data
        .brand_name[0],
      topProductsDataShow: false,
      topProductsLoaderForTabs: true,
      barColors: [
        "#065559",
        "#6AB7A8",
        "#B5DBD4",
        "#9ABABC",
        "#DAEDE9",
        "#76999A",
      ],
      loaderUpdated: false,
      showNoDataImgForUser: false,
      selectedProduct: [],
      productList: [],
      ratingCountList: [],
      ratingCountTableShow: false,
      ratingTableloader: false,
      viewModalTrendLineData: [],
      procedModalTrandLineData: { xAxis: [] },
      ComProductList: [],
      ComProductList1: [],
      selectedCompBrand: [],
      selectedCompBrand1: [],
      reviewLineChartInterval: "week_on_week",
      selectedTableCategory: [],
      categoryList: [],
      selectedTableSubCategory: "",
      subCategoryList: [],
      allCategory: [],
      searchGraph: {},
      proccedNetSalesGraphData: {},
    };
  },
  mounted() {
    const data = localStorage.getItem("reviewUserData");
    if (data) {
      const res = JSON.parse(data);
      if (res.data.brand_name[0] == "colgate") {
        this.dateRange = {
          startDate: moment().subtract(3, "years").format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
        };
      }
    }
    this.processRatingTable("#rating-table");
    this.getLastUpdatedDates();
    this.$store.dispatch("DemoStore/setTimeStamp", ""); //using for clear the last updated time stamp
    this.$store.dispatch("DemoStore/setUpdatedStatus", "");
  },
  computed: {
    ...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),
  },
  watch: {
    allProducts: {
      handler(newVal) {
        const platformId = this.selectedPlatform.platform_id;
        if (this.selectedCompBrand1 && platformId) {
          this.ComProductList =
            newVal[platformId]?.filter(
              (data) => data.id == this.selectedCompBrand1.id
            ) || [];
        }

        if (this.selectedCompBrand) {
          this.ComProductList1 =
            newVal[platformId]?.filter(
              (data) => data.id == this.selectedCompBrand.id
            ) || [];
        }
      },
      deep: true,
      immediate: true,
    },

    selectedCompBrand1(newBrand) {
      const products =
        this.allProducts[this.selectedPlatform.platform_id] || [];
      this.ComProductList = products.filter((data) => data.id == newBrand?.id);
      this.comparisonList[0].selectedProduct = [];
    },

    selectedCompBrand(newBrand) {
      const products =
        this.allProducts[this.selectedPlatform.platform_id] || [];
      this.ComProductList1 = products.filter((data) => data.id == newBrand?.id);
      if (this.comparisonList[1]) {
        this.comparisonList[1].selectedProduct = [];
      }
    },
    reviewLineChartInterval(newVal) {
      this.comparisonList.forEach((item, index) => {
        if (item.performanceData) {
          this.comparisonList[index].viewModalTrendLineData =
            item.performanceData[newVal];
          this.processReviewTrendlineGraph(index);
        }
      });
    },
    selectedTableCategory(newVal) {
      let mergedChildren = [];
      newVal.forEach((cat) => {
        if (cat.child && Array.isArray(cat.child)) {
          mergedChildren.push(...cat.child);
        }
      });
      this.subCategoryList = mergedChildren;

      this.selectedTableSubCategory = this.subCategoryList[0];
      const validKeys = new Set(mergedChildren.map((c) => c.key));
      this.selectedTableSubCategory = this.selectedTableSubCategory?.filter(
        (subcat) => validKeys.has(subcat.key)
      );
    },
  },
  methods: {
    ...mapActions("DemoStore", [
      "setSelectedLanguage",
      "initializeTranslation",
    ]),
    getLastUpdatedDates() {
      this.loaderUpdated = true;
      const url = `/api/v2/india_clients/last_update?client=${this.client}&feature_id=${this.featureId}`;
      this.$http
        .get(url)
        .then((response) => {
          if (response.body.data.reviews_and_ratings) {
            this.showNoDataImgForUser = false;
            this.dateRange.endDate = moment(
              response.body.data.reviews_and_ratings?.end_date
            ).format("YYYY-MM-DD");

            this.dateRange.startDate = moment(
                response.body.data.reviews_and_ratings?.end_date
            ).subtract(1,'month').format("YYYY-MM-DD");
            this.maxDate= response.body.data.reviews_and_ratings?.end_date
            this.minDate= response.body.data.reviews_and_ratings?.start_date

            this.getPlatformsAndCategories();
            this.loaderUpdated = false;
          } else {
            this.showNoDataImgForUser = true;
            this.loaderUpdated = false;
          }
        })
        .catch((err) => {
          this.loaderUpdated = false;
          console.log("err", err);
        })
        .finally(() => {
          this.loaderUpdated = false;
        });
    },
    getFiltersData() {
      let self = this;
      self.vocProductListLoader = true;
      const url = "/api/v2/product/filter_data";
      let payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };
      self.$http
        .post(url, payload)
        .then((response) => {
          this.allCategory = response.data.data.category;
          this.categoryList = [];
          this.subCategoryList = [];
          const categoryMap = new Map();

          this.platforms.forEach((platform) => {
            const platformKey = platform.platform_id;
            const categories = this.allCategory[platformKey];

            if (categories?.length) {
              categories.forEach((cat) => {
                if (!categoryMap.has(cat.key)) {
                  categoryMap.set(cat.key, cat);
                  this.categoryList.push(cat);
                }
              });
            }
            this.selectedTableCategory = [this.categoryList[0]];
            const firstCategory = this.categoryList[0];
            if (firstCategory && firstCategory.child?.length) {
              this.subCategoryList = firstCategory.child;
              this.selectedTableSubCategory = this.subCategoryList[0];
            }
          });
          this.getAllProducts();
        })
        .catch((err) => {
          console.log(err);
          self.vocProductListLoader = false;
        });
    },
    percentage(rating) {
      return (rating / this.maxRating) * 100;
    },
    navigateWordCloud(id) {
      document.getElementById(id).scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
    },
    changePlatform() {
      this.selectedCategory =
        this.categories[this.selectedPlatform.platform_id][0];
      this.topProductsDataShow = false;
      // this.selectedGlobalBrand = this.allBrands[this.selectedPlatform.platform_id][0];
      this.getAllProducts();
      this.getProductIdData();
    },
    handleCategory() {
      this.getAllProducts();
      this.getProductIdData();
    },
    backToTopPerformance() {
      // this.productCompare = false;
      // this.comparisonList = [];
      localStorage.removeItem("compareProducts");
      // this.getTopProducts();
      location.reload();
    },
    goToProductSentiments() {
      localStorage.setItem("compareProducts", true);
      if (this.selectedView) {
        localStorage.setItem("savedView", this.selectedView.view_id);
      }
      this.$nextTick(() => {
        this.$router.push("/sentiment/product");
      });
    },
    applyFilters() {
      if ($.fn.DataTable.isDataTable("#rating-table")) {
        $("#rating-table").DataTable().destroy();
      }
      this.ratingCountTableShow = false;
      if (!this.productCompare) {
        this.$nextTick(() => {
          this.getTopProducts();
        });
      } else {
        for (let itemIndex in this.comparisonList) {
          this.getProductReviews(itemIndex);
        }
        if (this.comparisonList.length > 1) {
          this.updateVOCData();
        }
      }
      this.getRatingCountData();
    },

    getInsightsData() {
      this.getKeywordInsightsData();
      this.getMostReviewsInsightsData();
      this.getWorstReviewsInsightsData();
    },

    setProductComparison() {
      this.comparisonList = [];
      this.getSavedViews();
      this.prepareComparisonList();
      if ($.fn.DataTable.isDataTable("#rating-table")) {
        $("#rating-table").DataTable().destroy();
      }
      this.productCompare = true;
    },
    updateVOCData() {
      this.getReviewCount();
      this.getVoiceOfCustomer();
    },
    updateComparisonData(index) {
      this.getProductReviews(index);
      if (this.comparisonList.length > 1) {
        this.updateVOCData();
      }
    },
    removeCompareCard(index) {
      this.comparisonList.splice(index, 1);
    },
    prepareComparisonList() {
      if (!this.comparisonList.length) {
        this.comparisonList.push({
          selectedProduct: [this.defaultComparisonProduct],
          ratingsData: {},
          sentiments: [],
          currentTab: "Sentiment Overview",
          img: "",
          viewModalTrendLineData: [],
          trendlineData: null,
          barGraphData: {},
          multiTrendLineData: null,
        });
        this.getProductReviews(0);
      } else {
        this.comparisonList.push({
          selectedProduct: [],
          ratingsData: {},
          sentiments: [],
          currentTab: "Sentiment Overview",
          img: "",
          viewModalTrendLineData: [],
          trendlineData: null,
          barGraphData: {},
          multiTrendLineData: null,
        });
      }

      this.$nextTick(() => {
        if (this.comparisonList.length > 1 && this.comparisonList.length < 5) {
          document
            .getElementById(`compare-card-${this.comparisonList.length - 1}`)
            .scrollIntoView({
              behavior: "smooth",
              block: "nearest",
              inline: "start",
            });
          const main = document.getElementsByTagName("main");
          main.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        }
      });
    },
    getUpdatedProduct(index) {
      this.getProductReviews(index);
      if (this.comparisonList.length > 1) {
        this.updateVOCData();
      }
    },
    slideTab(id, tabName, index) {
      this.comparisonList[index].currentTab = tabName;
      document.getElementById(id).scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "nearest",
      });
    },
    handleChangeInterval() {
    },
    getAllProducts() {
      this.vocData = [];
      this.vocPieChart = [];
      this.vocStack = {};
      this.reviewCountChart = {};

      const url = "/api/v2/indian_clients/product_brand";
      const payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        client: this.client,
        channel: this.selectedPlatform?.platform_id,
        category: this.selectedTableSubCategory?.key,
        label: "product",
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };

      this.loader = true;
      this.$http
        .post(url, payload)
        .then((res) => {
          res.body.data[this.selectedPlatform?.platform_id].map((brand) => {
            brand.children.map((product, index) => {
              product.id = `${brand.id}+${product.id}`;
              if (brand.id === this.brandNameFromLogin && index === 0) {
                this.defaultComparisonProduct = product.id;
              }
              // This check is only for demo account, can be removed later if fouund a good solution
              else if (this.client === "lyxel_labs") {
                if (brand.id === "godrej") {
                  this.defaultComparisonProduct = product.id;
                }
              }
            });
          });

          this.allProducts = res.body.data;
          
          if (localStorage.savedView) {
            this.getSavedViews();
          } else {
            this.plotProducts();
          }
          this.loader = false;
        })
        .catch((err) => {
          this.loader = false;
          console.log("Error in getting all products", err);
        });
    },
    getPlatformsAndCategories() {
      this.platforms = [];
      this.selectedPlatform = "";
      this.categories = {};
      this.selectedCategory = [];

      const url = "/api/v2/india_clients/product_platform_details";
      const payload = {
        client: this.client,
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        non_sov: true,
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };

      this.loader = true;

      this.$http
        .post(url, payload)
        .then((res) => {
          this.loader = false;
          this.platforms = res.body.data.platform;
          this.selectedPlatform = this.platforms[0];
          this.categories = res.body.data.price;
          this.selectedCategory =
            this.categories[this.selectedPlatform.platform_id][0];
          this.getFiltersData();
          this.getAllBrands();
          if (localStorage.compareProducts) {
            this.productCompare = localStorage.compareProducts;
          }

          localStorage.removeItem("compareProducts");
        })
        .catch((err) => {
          this.loader = false;
          console.log("Error in fetching platforms and categories", err);
        });
    },
    plotProducts() {
      this.$nextTick(() => {
        if (this.productCompare) {
          this.comparisonList = [];
          this.prepareComparisonList();
        } else {
          this.getTopProducts();
        }
      });
    },
    switchTab(tabName) {
      this.topProductsDataShow = false;
      this.selectedTab = tabName;
      this.getTopProducts();
    },
    getKeywordInsightsData() {
      const url = "/api/v2/new/keyword";
      const productDetails = this.selectedGlobalProduct.split("+");
      const brandName = productDetails[0];
      const productID = productDetails[1];
      this.viewKeywordInsightsData = "";
      const payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        channel: this.selectedPlatform.platform_id,
        brand: [brandName],
        category: [this.selectedTableSubCategory.key],
        product: [productID],
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          this.viewKeywordInsightsData = res.body.data;
        })
        .catch((err) => {
          this.modalLoader = false;
          console.log(`Error in keyword insights`, err);
        });
    },

    getMostReviewsInsightsData() {
      const url = "/api/v2/most/reviews";
      const productDetails = this.selectedGlobalProduct.split("+");
      const brandName = productDetails[0];
      const productID = productDetails[1];
      this.viewKeywordInsightsData = "";
      const payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        channel: this.selectedPlatform.platform_id,
        brand: [brandName],
        category: [this.selectedTableSubCategory.key],
        product: [productID],
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          this.viewMostReviewsInsightsData = res.body.data;
        })
        .catch((err) => {
          this.modalLoader = false;
          console.log(`Error in  most reviews insights`, err);
        });
    },

    getWorstReviewsInsightsData() {
      const url = "/api/v2/worst/reviews";
      const productDetails = this.selectedGlobalProduct.split("+");
      const brandName = productDetails[0];
      const productID = productDetails[1];
      this.viewKeywordInsightsData = "";
      const payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        channel: this.selectedPlatform.platform_id,
        brand: [brandName],
        category: [this.selectedTableSubCategory.key],
        product: [productID],
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };
      this.$http
        .post(url, payload)
        .then((res) => {
          this.viewWorstReviewsInsightsData = res.body.data;
        })
        .catch((err) => {
          this.modalLoader = false;
          console.log(`Error in  worst reviews insights`, err);
        });
    },

    getTopProducts() {
      const url = "/api/v2/indian_clients/top_products";
      const payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        client: this.client,
        channel: this.selectedPlatform.platform_id
          ? [this.selectedPlatform.platform_id]
          : [],
        brand: [this.selectedGlobalBrand.id],
        category: [this.selectedTableSubCategory.key],
        key_value: this.tabKeyMapper[this.selectedTab].keyVal,
        key_type: this.tabKeyMapper[this.selectedTab].keyType,
        language: this.$store.state.DemoStore.selectedLanguage.key,
        product: this.selectedProduct.map((product) => product.key),
        product_type: "sku",
      };

      this.topProductsLoaderForTabs = true;
      this.topProducts = [];

      this.$http
        .post(url, payload)
        .then((res) => {
          this.topProductsLoaderForTabs = false;
          this.topProductsDataShow = res.body.data_present;
          if (res.body.data) {
            this.topProducts = res.body.data;

            if (this.selectedTab === "Top Reviewed") {
              this.selectedGlobalProduct = `${this.selectedGlobalBrand.id}+${res.body.data[0].product_id}`;
              this.getCategoryWiseProducts();
            }
          }
        })
        .catch((err) => {
          this.topProductsLoaderForTabs = false;
          console.log(`Error in getting top products`, err);
        });
    },

    getProductReviews(index = 0) {
      const productDetails =
        this.comparisonList[index].selectedProduct[0].split("+");
      const brandName = productDetails[0];
      const extractedValues = this.comparisonList[index].selectedProduct.map(
        (item) => item.split("+")[1]
      );
      const productName = extractedValues;

      this.comparisonList[index].ratingsData = {};
      this.comparisonList[index].sentiments = [];
      this.comparisonList[index].viewModalTrendLineData = [];

      // const url = "/api/v2/indian_clients/compare_data";
      const url = "/api/v2/boat/review_compare";
      const payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        client: this.client,
        channel: [this.selectedPlatform.platform_id],
        language: this.$store.state.DemoStore.selectedLanguage.key,
        product: productName,
        is_product: true,
        brand: [brandName],
      };

      this.reviewLoader = true;

      this.$http
        .post(url, payload)
        .then((res) => {
          this.reviewLoader = false;
          this.getBrandImage(brandName);
          const data = res.data.data;

          if (
            data.performance?.month_on_month ||
            data.performance?.week_on_week
          ) {
            // 🔹 SINGLE PRODUCT
            this.comparisonList[index].ratingsData = data.ratings;
            this.comparisonList[index].performanceData = data.performance;
            this.comparisonList[index].viewModalTrendLineData =
              data.performance[this.reviewLineChartInterval];

            this.processReviewTrendlineGraph(index);
          } else if (Array.isArray(data.performance)) {
            // 🔹 MULTIPLE PRODUCTS
            this.comparisonList[index].ratingsData = data.rating_count;
            this.comparisonList[index].performanceData = data.performance;
            this.comparisonList[index].viewModalTrendLineData =
              data.performance;
            this.processMultiProductReviewTrendlineGraph(index);
            this.processNetSalesGraph(index);
          }
        })
        .catch((err) => {
          this.reviewLoader = false;
          console.log(`Error in getting product review`, err);
        });
    },
    processReviewTrendlineGraph(index) {
      this.comparisonList[index].trendlineData = {};

      const performance = this.comparisonList[index].viewModalTrendLineData;

      if (!performance || performance.length === 0) return;

      const xAxisData = performance?.map((item) =>
        moment(item.date).format("D MMM")
      );
      const starCategories = Object.keys(performance[0]).filter(
        (data) => data != "date"
      );
      const colorList = ["#B91C1C", "#46A493", "#F9B429", "#0463BA", "#065559"];

      const seriesData = starCategories?.map((star, idx) => ({
        name: star,
        color: colorList[idx],
        marker: {
          enabled: true,
          lineWidth: 3,
          fillColor: "#fff",
          lineColor: colorList[idx],
          radius: 4,
          symbol: "circle",
        },
        dataLabels: {
          enabled: false,
          allowOverlap: true,
          style: { fontWeight: "normal" },
          formatter() {
            return "₹" + this.point.y.toLocaleString();
          },
        },
        data: performance.map((item) => item[star]),
      }));

      this.comparisonList[index].trendlineData = {
        id: `reviewTrendlineGraph-${index}`,
        xAxis: xAxisData,
        seriesData: seriesData,
      };
    },
    processMultiProductReviewTrendlineGraph(index) {
      this.comparisonList[index].multiTrendLineData = {};
      const performance = this.comparisonList[index].viewModalTrendLineData;

      if (!performance || performance.length === 0) return;

      const xAxisData = performance?.map((item) =>
        moment(item.date).format("D MMM")
      );

      const asinKeys = Object.keys(performance[0]).filter(
        (key) => key !== "date"
      );

      const colorList = ["#B91C1C", "#46A493", "#F9B429", "#0463BA", "#065559"];

      const seriesData = asinKeys.map((asin, idx) => ({
        name: asin,
        color: colorList[idx % colorList.length],
        marker: {
          enabled: true,
          lineWidth: 3,
          fillColor: "#fff",
          lineColor: colorList[idx % colorList.length],
          radius: 4,
          symbol: "circle",
        },
        dataLabels: {
          enabled: false,
          allowOverlap: true,
          style: { fontWeight: "normal" },
        },
        data: performance.map((item) => item[asin] || 0),
      }));

      this.comparisonList[index].multiTrendLineData = {
        id: `reviewTrendlineGraph-${index}`,
        xAxis: xAxisData,
        seriesData: seriesData,
      };
    },
    processNetSalesGraph(index) {
      this.proccedNetSalesGraphData = null;
      const rating_count = this.comparisonList[index].ratingsData;

      const colorMapper = ["#F9B429", "#9DB8FD", "#95CDD5", "#F4C8A0"];
      const tempKey = Object.keys(rating_count);
      const data = {
        xAxis: [""],
        yAxis: [],
        seriesData: tempKey.map((item, idx) => {
          return {
            name: item,
            key: item,
            type: "bar",
            color: colorMapper[idx % colorMapper.length],
            dataLabels: {
              enabled: true,
              formatter() {
                return this.y.toLocaleString();
              },
            },
            data: [rating_count[item]],
          };
        }),
      };
      this.proccedNetSalesGraphData = data;
      this.$set(
        this.comparisonList[index],
        "barGraphData",
        this.proccedNetSalesGraphData
      );
    },
    getVoiceOfCustomer() {
      let products = this.comparisonList.map(
        (product) => product.selectedProduct[0].split("+")[1]
      );
      this.numberOfReviews = [];
      this.reviewCountChart = {};
      this.vocData = [];
      this.vocPieChart = [];
      this.vocStack = {};

      const url = `/api/v2/reviews/bulk?`;

      const payload = {
        channel: this.selectedPlatform.platform_id,
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        interval: "month",
        products: products,
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };
      this.vocLoader = true;

      this.$http
        .post(url, payload)
        .then((res) => {
          this.vocLoader = false;
          this.vocData = res.body.data;
          this.$nextTick(() => {
            this.plotVOCCharts();
          });
        })
        .catch((err) => {
          this.vocLoader = false;
          console.log(`Error in getting voice of customers`, err);
        });
    },
    plotVOCCharts() {
      const pieColors = ["#FCB117", "#46A493", "#899EFC"];

      let stackCategories = [];
      let positiveData = [];
      let negativeData = [];
      let neutralData = [];

      let pieChartData = [
        {
          name: "Voice of Customers",
          colorByPoint: true,
          data: [],
        },
      ];

      this.vocData.map((series, index) => {
        stackCategories.push(series.product_name);

        positiveData.push(series.rating_sentiment.positive.count);
        negativeData.push(series.rating_sentiment.negative.count);
        neutralData.push(series.rating_sentiment.neutral.count);

        pieChartData[0].data.push({
          name: series.product_name,
          y: series.count,
          color: pieColors[index],
        });
      });

      this.vocStack = {
        categories: stackCategories,
        seriesData: [
          {
            name: "Positive",
            data: positiveData,
            color: "#46a493",
            borderRadius: "15px",
          },
          {
            name: "Neutral",
            data: neutralData,
            color: "#dcdcdc",
            borderRadius: 0,
          },
          {
            name: "Negative",
            data: negativeData,
            color: "#fc8484",
            borderRadius: 0,
          },
        ],
      };

      this.vocPieChart = pieChartData;
    },
    changeCountInterval() {
      this.$nextTick(() => {
        this.getReviewCount();
      });
    },
    getReviewCount() {
      let products = this.comparisonList.map(
        (product) => product.selectedProduct[0].split("+")[1]
      );
      this.numberOfReviews = [];
      this.reviewCountChart = {};

      let startDate = moment(this.dateRange.startDate).format("YYYY-MM-DD");
      if (
        this.reviewCountInterval === "week" ||
        this.reviewCountInterval === "day"
      ) {
        startDate = moment(this.dateRange.endDate)
          .subtract(1, "month")
          .format("YYYY-MM-DD");
      }

      const url = `/api/v2/reviews/histogram`;

      const payload = {
        channel: this.selectedPlatform.platform_id,
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        interval: this.reviewCountInterval,
        products: products,
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };

      this.countLoader = true;

      this.$http
        .post(url, payload)
        .then((res) => {
          this.countLoader = false;
          this.numberOfReviews = res.body.data;
          this.prepareReviewCountChartData();
        })
        .catch((err) => {
          this.countLoader = false;
          console.log(`Error in getting review count timeline data`, err);
        });
    },
    prepareReviewCountChartData() {
      let colors = ["#FCB117", "#46A493", "#899EFC"];
      let xAxisData = [];
      let yAxisData = [];

      this.numberOfReviews.forEach((reviewSeries, index) => {
        yAxisData.push({
          name: reviewSeries.product_name,
          data: [],
          color: colors[index],
        });

        reviewSeries.timeline.forEach((seriesData) => {
          if (index === 0) {
            xAxisData.push(moment(seriesData.date).format("DD MMM"));
          }
          yAxisData[index].data.push(seriesData.review_count);
        });
      });

      this.reviewCountChart = {
        categories: xAxisData,
        seriesData: yAxisData,
      };
    },
    getBrandImage(brandName) {
      const url = "/api/v2/brand/images";
      const targetView = this.savedViews?.find(
        (view) => view.view_id === this.selectedView.view_id
      );

      const compareBrandPayload = [];
      targetView?.product_filter?.map((brand, index) => {
        compareBrandPayload.push({
          brand_name: brand.selectedBrand,
        });
      });
      const payload = {
        brand: targetView
          ? compareBrandPayload.map((brand) => brand.brand_name)
          : [brandName],
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          const brandImageMap = {};

          res.body.data.forEach((item) => {
            brandImageMap[item.brand.toLowerCase()] = item.url;
          });
          this.comparisonList.forEach((brand, index) => {
            const productName = brand.selectedProduct[0]?.split("+")[0];

            if (productName && brandImageMap[productName]) {
              this.comparisonList[index].img = brandImageMap[productName];
            }
          });
        })
        .catch((err) => {
          console.log("Error in getting compare brand data", err);
        });
    },
    getSelectedSavedView() {
      this.savedViewLoader = true;
      this.comparisonList = [];
      this.getBrandImage();

      const targetView = this.savedViews.find(
        (view) => view.view_id === this.selectedView.view_id
      );

      this.dateRange = targetView.page_filter.dateRange;
      this.selectedPlatform = targetView.page_filter.selectedPlatform;
      this.selectedCategory = targetView.page_filter.selectedCategory;

      const compareBrandPayload = [];

      targetView.product_filter.map((brand, index) => {
        this.comparisonList.push({
          selectedProduct: [`${brand.selectedBrand}+${brand.selectedProduct}`],
          ratingsData: {},
          sentiments: [],
          currentTab: "Sentiment Overview",
          img: "",
          viewModalTrendLineData: [],
          trendlineData: null,
          barGraphData: null,
          multiTrendLineData: null,
        });

        compareBrandPayload.push({
          brand_name: brand.selectedBrand,
          category_name: this.selectedTableSubCategory.key,
          product_id: brand.selectedProduct,
        });
      });

      this.$nextTick(() => {
        const url = "/api/v2/boat/review_compare";
        // const url = "/api/v2/indian_clients/compare_data";
        const payload = {
          start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
          end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
          client: this.client,
          channel: [this.selectedPlatform.platform_name],
          brand: compareBrandPayload.map((brand) => brand.brand_name),
          product: compareBrandPayload.flatMap((product) => product.product_id),
          // compare_type: "product",
          save_view: true,
          is_product: true,
          language: this.$store.state.DemoStore.selectedLanguage.key,
        };

        this.reviewLoader = true;

        this.$http
          .post(url, payload)
          .then((res) => {
            this.reviewLoader = false;
            this.savedViewLoader = false;
            this.comparisonList.forEach((brand, index) => {
              const productName = brand.selectedProduct[0].split("+")[1];

              this.comparisonList[index].ratingsData =
                res.body.data[productName].ratings;

              this.comparisonList[index].viewModalTrendLineData =
                res.body.data[productName].performance[
                  this.reviewLineChartInterval
                ];
              this.processReviewTrendlineGraph(index);
              // this.comparisonList[index].sentiments =
              //   res.body.data[productName].sentiment;
              // this.comparisonList[index].img =
              //   res.body.data[productName].product_image;
            });

            this.$nextTick(() => {
              this.getVoiceOfCustomer();
              this.getReviewCount();
            });
            // this.getSelectedProduct();
          })
          .catch((err) => {
            this.reviewLoader = false;
            console.log("Error in getting compare brand data", err);
          });
        this.savedViewLoader = false;
      });
    },
    resetViewModal() {
      this.viewModalName = "";
      this.newViewName = "";
      this.modalViewOptions = [];
      this.showViewModal = false;
    },
    openViewModal(viewType) {
      this.modalViewOptions = [
        ...this.viewOptions,
        {
          view_id: "add_new",
          view_name: "Add New",
        },
      ];

      if (viewType === "Edit View") {
        this.newViewName = this.selectedView.view_name;
      } else if (viewType === "Save View") {
        this.selectedModalView = {
          view_id: "add_new",
          view_name: "Add New",
        };

        this.newViewName = "";
      }

      this.$nextTick(() => {
        this.viewModalName = viewType;
        this.showViewModal = true;
      });
    },
    getSavedViews() {
      this.savedViews = [];
      this.viewOptions = [];
      const url =
        "/api/v2/reviews/comparison_view?view_for=product_reviews_compare";

      this.$http
        .get(url)
        .then((res) => {
          this.savedViews = res.data.data;
          if (this.savedViews.length) {
            this.savedViews.map((view) => {
              this.viewOptions.push({
                view_id: view.view_id,
                view_name: view.view_name,
              });
            });
          }

          if (localStorage.savedView) {
            this.selectedView = this.viewOptions.find(
              (view) => view.view_id === localStorage.savedView
            );
            localStorage.removeItem("savedView");
            this.$nextTick(() => {
              this.getSelectedSavedView();
            });
          }

          if (
            this.viewModalName === "Edit View" ||
            (this.viewModalName === "Save View" &&
              this.selectedModalView.view_id === "add_new")
          ) {
            this.selectedView = this.viewOptions.find(
              (view) => view.view_name === this.newViewName
            );
            this.resetViewModal();
          } else this.resetViewModal();
        })
        .catch((err) => {        
          console.log(`Error getting saved views:: ${err}`);
        });
    },
    saveCompareView() {
      if (this.viewModalName === "Edit View" && !this.newViewName) {
        this.$bvToast.toast("Please provide a name to edit this view", {
          title: "Edit View",
          variant: "danger",
          solid: true,
          toaster: "b-toaster-top-right",
          autoHideDelay: 2000,
          appendToast: true,
        });
        return;
      } else if (
        this.selectedModalView.view_id === "add_new" &&
        !this.newViewName
      ) {
        this.$bvToast.toast("Please provide a name to save new view", {
          title: "Save View",
          variant: "danger",
          solid: true,
          toaster: "b-toaster-top-right",
          autoHideDelay: 2000,
          appendToast: true,
        });
        return;
      }

      this.spinLoader = true;

      if (this.newViewName) {
        let capitalizedText;
        capitalizedText = this.newViewName
          .split(" ")
          .map(
            (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          )
          .join(" ");

        this.newViewName = capitalizedText;
      }

      const url = "/api/v2/reviews/comparison_view";
      let payload = {
        view_for: "product_reviews_compare",
        view_data: {
          page_filter: {
            dateRange: {
              startDate: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
              endDate: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
            },
            selectedPlatform: this.selectedPlatform,
            selectedCategory: this.selectedTableSubCategory,
          },
          product_filter: this.comparisonList.map((compareProduct) => {
            return {
              selectedBrand: compareProduct.selectedProduct[0].split("+")[0],
              selectedProduct: compareProduct.selectedProduct.map(
                (data) => data.split("+")[1]
              ),
            };
          }),
          view_name: this.newViewName,
        },
      };

      if (this.viewModalName === "Edit View") {
        payload = {
          ...payload,
          view_id: this.selectedView.view_id,
        };
      }

      if (
        this.viewModalName === "Save View" &&
        this.selectedModalView.view_id !== "add_new"
      ) {
        (payload.view_data.view_name = this.selectedModalView.view_name),
          (payload = {
            ...payload,
            view_id: this.selectedModalView.view_id,
          });
      }

      this.$http
        .post(url, payload)
        .then((res) => {
          this.getSavedViews();
          this.spinLoader = false;
        })
        .catch((err) => {
          console.log("sdfkldsjf",err.body.msg);
          this.$bvToast.toast(err?.body.msg, {
              title: "Save Error",
              variant: "danger",
              solid: true,
              toaster: "b-toaster-top-right",
              autoHideDelay: 3000,
              appendToast: true,
          });
          console.log(`Error in saving view::${err}`);
          this.spinLoader = false;
        });
    },
    resetComparisonList() {
      if (this.productCompare) {
        this.comparisonList = [];
        this.$nextTick(() => {
          this.prepareComparisonList();
        });
      }
    },
    resetSavedView() {
      this.selectedView = "";
      this.resetComparisonList();
    },
    deleteView() {
      const url = "/api/v2/reviews/comparison_view";
      let payload = {
        view_id: [this.selectedView.view_id],
        view_for: "product_reviews_compare",
      };

      this.spinLoader = true;
      this.$http
        .delete(url, { body: payload })
        .then((res) => {
          this.getSavedViews();
          this.resetSavedView();

          this.$bvToast.toast("View deleted successfully", {
            title: "Delete View",
            variant: "success",
            solid: true,
            toaster: "b-toaster-top-right",
            autoHideDelay: 2000,
            appendToast: true,
          });

          this.spinLoader = false;
        })
        .catch((err) => {
          console.log(err);
          this.$bvToast.toast("Error in deleting this view", {
            title: "Delete View",
            variant: "danger",
            solid: true,
            toaster: "b-toaster-top-right",
            autoHideDelay: 2000,
            appendToast: true,
          });
          this.spinLoader = false;
        });

      this.showDeleteModal = false;
    },
    downloadReviews() {
      this.reviewLoader = true;
      const url = "/api/v2/reviews/brand";
      const payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        channel: [this.selectedPlatform.platform_id],
        category: this.selectedTableSubCategory
          ? [this.selectedTableSubCategory.key]
          : [],
        language: this.$store.state.DemoStore.selectedLanguage.key,
        product: this.selectedProduct.length
          ? this.selectedProduct?.map((product) => product.key)
          : [],
        is_sku: true,
        filter_type: "product",
        brand: [this.selectedGlobalBrand.id],
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          this.reviewLoader = false;
          window.location = res.body.data.file_url;
        })
        .catch((err) => {
          this.$bvToast.toast("Error in downloading reviews", {
            title: "Download Reviews",
            variant: "danger",
            solid: true,
            toaster: "b-toaster-top-right",
            autoHideDelay: 2000,
            appendToast: true,
          });
          console.log("Error in downloading report", err);
        });
    },
    handleExportTable() {
      this.reviewLoader = true;
      const url = "/api/v2/reviews/sheet";
      const payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        channel: [this.selectedPlatform.platform_id],
        category: this.selectedTableSubCategory
          ? [this.selectedTableSubCategory.key]
          : [],
        language: this.$store.state.DemoStore.selectedLanguage.key,
        product: this.selectedProduct.length
          ? this.selectedProduct?.map((product) => product.key)
          : [],
        is_sku: true,
        filter_type: "product",
        brand: [this.selectedGlobalBrand.id],
      };
      this.$http
        .post(url, payload)
        .then((res) => {
          this.reviewLoader = false;
          window.location = res.body.data.file_url;
        })
        .catch((err) => {
          this.$bvToast.toast("Error in downloading reviews", {
            title: "Download Reviews",
            variant: "danger",
            solid: true,
            toaster: "b-toaster-top-right",
            autoHideDelay: 2000,
            appendToast: true,
          });
          console.log("Error in downloading report", err);
        });
    },
    filterCustomDate(filter) {
      switch (filter) {
        case "Overview":
          this.selectedFilterState = filter;
          this.dateRange = {
            startDate: moment().startOf("year").format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
          };
          this.getSelectedProduct();
          break;
        case "Last Week":
          this.selectedFilterState = filter;
          this.dateRange = {
            startDate: moment()
              .subtract(1, "week")
              .startOf("week")
              .format("YYYY-MM-DD"),
            endDate: moment()
              .subtract(1, "week")
              .endOf("week")
              .format("YYYY-MM-DD"),
          };
          this.getSelectedProduct();
          break;
        case "Last Month":
          this.selectedFilterState = filter;
          this.dateRange = {
            startDate: moment()
              .subtract(1, "month")
              .startOf("month")
              .format("YYYY-MM-DD"),
            endDate: moment()
              .subtract(1, "month")
              .endOf("month")
              .format("YYYY-MM-DD"),
          };
          this.getSelectedProduct();
          break;
        case "Last Year":
          this.selectedFilterState = filter;
          this.dateRange = {
            startDate: moment()
              .subtract(1, "year")
              .startOf("year")
              .format("YYYY-MM-DD"),
            endDate: moment()
              .subtract(1, "year")
              .endOf("year")
              .format("YYYY-MM-DD"),
          };
          this.getSelectedProduct();
          break;
        default:
          break;
      }
    },
    getAllBrands() {
      const url = "/api/v2/indian_clients/product_brand";
      const payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        client: this.client,
        label: "brand",
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };

      this.allBrands = null;
      this.reviewsLoader = true;
      this.$http
        .post(url, payload)
        .then((res) => {
          this.allBrands = res.body.data;
          this.reviewsLoader = false;

          this.selectedGlobalBrand = this.allBrands[
            this.selectedPlatform.platform_id
          ].find((brand) => {
            if (this.client === "lyxel_labs") {
              return brand.id === "godrej";
            }
            return brand.id === this.brandNameFromLogin;
          });
          this.selectedCompBrand = this.allBrands[
            this.selectedPlatform.platform_id
          ].find((brand) => {
            if (this.client === "lyxel_labs") {
              return brand.id === "godrej";
            }
            return brand.id === this.brandNameFromLogin;
          });
          this.selectedCompBrand1 = this.allBrands[
            this.selectedPlatform.platform_id
          ].find((brand) => {
            if (this.client === "lyxel_labs") {
              return brand.id === "godrej";
            }
            return brand.id === this.brandNameFromLogin;
          });

          this.getProductIdData();
          this.getRatingCountData();
          this.$nextTick(() => {
            this.getTopProducts();
          });
        })
        .catch((err) => {
          console.log("Error in getting all brands", err);
          this.reviewsLoader = false;
        });
    },
    getCategoryWiseProducts() {
      const url = "/api/v2/indian_clients/product_brand";
      const payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        client: this.client,
        channel: this.selectedPlatform.platform_id,
        category: this.selectedTableSubCategory.key,
        label: "product",
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };

      this.loader = true;
      this.$http
        .post(url, payload)
        .then((res) => {
          res.body.data[this.selectedPlatform.platform_id].map((brand) => {
            brand.children.map((product, index) => {
              product.id = `${brand.id}+${product.id}`;
            });
          });

          this.categoryWiseProducts = res.body.data;

          this.$nextTick(() => {
            this.getSelectedProduct();
            this.loader = false;
          });
        })
        .catch((err) => {
          this.loader = false;
          console.log("Error in getting all products", err);
        });
    },
    getSelectedProduct() {
      if (!this.selectedPlatform) {
        this.$bvToast.toast("Please select a platform", {
          title: "Edit View",
          variant: "danger",
          solid: true,
          toaster: "b-toaster-top-right",
          autoHideDelay: 2000,
          appendToast: true,
        });
        return;
      }

      if (!this.selectedTableSubCategory.key) {
        this.$bvToast.toast("Please select a Sub category", {
          title: "Edit View",
          variant: "danger",
          solid: true,
          toaster: "b-toaster-top-right",
          autoHideDelay: 2000,
          appendToast: true,
        });
        return;
      }

      if (!this.selectedGlobalProduct) {
        this.$bvToast.toast("Please select a product", {
          title: "Edit View",
          variant: "danger",
          solid: true,
          toaster: "b-toaster-top-right",
          autoHideDelay: 2000,
          appendToast: true,
        });
        return;
      }

      this.getInsightsData();
      this.getPerformanceRating();
      this.getBrandPerformanceRating();
      this.globalProductReviews = {};
      this.globalProductSentiments = {};
      this.globalProductAISummary = "";
      this.globalProductName = "";
      this.globalProductMarketShare = {};

      const productDetails = this.selectedGlobalProduct.split("+");
      const brandName = productDetails[0];
      const productID = productDetails[1];

      const url = "/api/v2/indian_clients/compare_data";
      const payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        client: this.client,
        channel: this.selectedPlatform.platform_id,
        compare: [
          {
            brand_name: brandName,
            category_name: this.selectedTableSubCategory.key,
            product_id: productID,
          },
        ],
        compare_type: "product",
        // positive_limit: Number(this.selectedPositiveCloudLimit),
        // negative_limit: Number(this.selectedNegativeCloudLimit)
        positive_limit: 50,
        negative_limit: 50,
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };

      this.reviewLoader = true;

      this.$http
        .post(url, payload)
        .then((res) => {
          const productData =
            res.body.data[this.selectedGlobalProduct.split("+")[1]];

          this.globalProductReviews = productData.reviews;
          this.globalProductSentiments = productData.sentiment;
          this.globalProductAISummary = productData.summary;
          this.globalProductName = productData.product_name;
          this.globalProductImage = productData.product_image;
          this.globalProductMarketShare = productData.market_share;

          this.reviewLoader = false;

          this.$nextTick(() => {
            this.processTable("#product-sentiments-table");
          });
        })
        .catch((err) => {
          this.reviewLoader = false;
          console.log(`Error in getting product review`, err);
        });
    },
    updateSelectedLabels(value) {
      return value.platform_name.replaceAll("_", " ");
    },
    getPerformanceRating() {
      const productDetails = this.selectedGlobalProduct.split("+");
      const brandName = productDetails[0];
      const productID = productDetails[1];

      const url = "/api/v2/reviews/starcount";
      const payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        channel: this.selectedPlatform.platform_id,
        brand: [brandName],
        category: [this.selectedTableSubCategory.key],
        product: [productID],
        interval: "month",
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };

      this.performanceRatingsData = [];
      this.reviewLoader = true;

      this.$http
        .post(url, payload)
        .then((res) => {
          this.performanceRatingsData = res.body.data;
          this.reviewLoader = false;
        })
        .catch((err) => {
          console.error(`Error in getting performance data::${err}`);
          this.reviewLoader = false;
        });
    },
     getBrandPerformanceRating() {
      const productDetails = this.selectedGlobalProduct.split("+");
      const brandName = productDetails[0];
      const productID = productDetails[1];

      const url = "/api/v2/reviews/starcount_buybox";
      const payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        channel: this.selectedPlatform.platform_id,
        // channel: "flipkart",
        brand: [brandName],
        category: [this.selectedTableSubCategory.key],
        product: [productID],
        // interval: "month",
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };

      this.brandPerformanceData = [];
      this.reviewLoader = true;

      this.$http
        .post(url, payload)
        .then((res) => {
          this.brandPerformanceData = res.body.data;
          this.reviewLoader = false;
        })
        .catch((err) => {
          console.error(`Error in getting performance data::${err}`);
          this.reviewLoader = false;
        });
    },
    processTable(id) {
      $(id).DataTable().destroy();

      $(id).DataTable({
        initComplete: function (settings, json) {
          $(".dataTables_scrollBody tfoot tr").css({ visibility: "collapse" });
          $(".dataTables_scrollBody thead tr").css({ visibility: "collapse" });
          $(id).wrap(
            "<div class='thin-scroller' style='overflow:auto; width:100%;position:relative;'></div>"
          );
        },
        columnDefs: [
          { orderData: 3, targets: 1 },
          { visible: false, targets: 3 },
          { orderable: false, targets: 2 },
        ],
        language: {
          search: "",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: "",
          },
          lengthMenu: "<h5>Show entries</h5> _MENU_",
          searchPlaceholder: "Search...",
        },

        pagingType: "full_numbers",
        searching: true,
        sorting: [[1, "desc"]],
        autoWidth: false,
      });

      let search = require("../../../public/Icons_SVG/Search.svg");
      $(id + "_filter > label").append(`<div><img src='${search}' /></div>`);
    },
    openNegativeModal(keyword) {
      this.openModal(keyword, "negative");
    },
    openPositiveModal(keyword) {
      this.openModal(keyword, "positive");
    },
    openModal(targetKeyword, sentType = "") {
      this.selectedModalKeyword = targetKeyword;
      this.modalTitle = `${
        this.translatedLang["Keyword"][this.selectedLanguage.key]
      } : ${targetKeyword.value}`;
      this.getKeywordReviews(sentType);
      this.getKeywordSentiment();
      this.keywordModal = true;
    },
    getKeywordReviews(sentimentType) {
      const productDetails = this.selectedGlobalProduct.split("+");
      const brandName = productDetails[0];
      const productName = productDetails[1];

      const url = "/api/v2/indian_clients/keyword_reviews_data";
      const payload = {
        start_date: moment(this.modalDateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.modalDateRange.endDate).format("YYYY-MM-DD"),
        keyword: this.selectedModalKeyword.key,
        client: this.client,
        channel: this.selectedPlatform.platform_id,
        brand_name: [brandName],
        language: this.$store.state.DemoStore.selectedLanguage.key,
        category_name: [this.selectedTableSubCategory.key],
        product_name: [productName],
        limit: 50,
        offset: 0,
        sentiment_type: sentimentType || "positive",
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };

      this.keywordWiseReviews = [];
      this.keywordTreeData = {};
      this.modalLoader = true;

      this.$http
        .post(url, payload)
        .then((res) => {
          this.modalLoader = false;
          this.keywordWiseReviews = res.body.data;
          this.keywordTreeData = res.body.percent;
        })
        .catch((err) => {
          this.modalLoader = false;
          console.log(`Error in fetching keyword reviews`, err);
        });
    },
    getKeywordSentiment() {
      const productDetails = this.selectedGlobalProduct.split("+");
      const brandName = productDetails[0];
      const productName = productDetails[1];

      const url = "/api/v2/indian_clients/keyword_sentiments_data";
      const payload = {
        start_date: moment(this.modalDateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.modalDateRange.endDate).format("YYYY-MM-DD"),
        keyword: this.selectedModalKeyword.key,
        interval: this.keywordInterval,
        client: this.client,
        language: this.$store.state.DemoStore.selectedLanguage.key,
        channel: this.selectedPlatform.platform_id,
        brand_name: [brandName],
        category_name: [this.selectedTableSubCategory.key],
        product_name: [productName],
      };

      this.keywordWiseSentiments = {};
      this.modalLoader = true;

      this.$http
        .post(url, payload)
        .then((res) => {
          this.modalLoader = false;
          this.keywordWiseSentiments = res.body.data;
        })
        .catch((err) => {
          this.modalLoader = false;
          console.log(`Error in fetching keyword sentiments`, err);
        });
    },
    resetModal() {
      this.selectedModalKeyword = "";
      this.modalTitle = "";
      this.keywordWiseReviews = [];
      this.keywordWiseSentiments = {};
      this.keywordTreeData = {};
      this.selectedModalTab = "Reviews";
      this.keywordInterval = "month";
    },
    updateModal() {
      this.getKeywordReviews();
      this.getKeywordSentiment();
    },
    filterReviews(sentimentType) {
      this.getKeywordReviews(sentimentType);
    },
    updateSentimentData() {
      this.$nextTick(() => {
        this.getKeywordSentiment();
      });
    },
    formatNumber(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getProductIdData() {
      this.selectedProduct = [];
      const url = "/api/v2/product/data";
      let payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        channel: this.selectedPlatform.platform_name
          ? [this.selectedPlatform.platform_name]
          : [],
        category: this.selectedTableSubCategory.key
          ? [this.selectedTableSubCategory.key]
          : [],
        brand: this.selectedGlobalBrand.id ? [this.selectedGlobalBrand.id] : [],
      };
      this.$http
        .post(url, payload)
        .then((res) => {
          this.productList = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getCompProductData() {
      this.selectedProduct = [];
      const url = "/api/v2/product/data";
      let payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        channel: this.selectedPlatform.platform_name
          ? [this.selectedPlatform.platform_name]
          : [],
        category: this.selectedTableSubCategory.key
          ? [this.selectedTableSubCategory.key]
          : [],
        brand: this.selectedGlobalBrand.id ? [this.selectedGlobalBrand.id] : [],
      };
      this.$http
        .post(url, payload)
        .then((res) => {
          this.productList = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getRatingCountData() {
      this.ratingCountTableShow = false;
      this.ratingTableloader = true;
      this.ratingCountList = [];

      const url = "/api/v2/boat/rating_count";
      const payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        client: this.client,
        brand: this.selectedGlobalBrand.id ? [this.selectedGlobalBrand.id] : [],
        channel: this.selectedPlatform?.platform_name
          ? [this.selectedPlatform.platform_name]
          : [],
        category: this.selectedTableSubCategory.key
          ? [this.selectedTableSubCategory.key]
          : [],
        product: this.selectedProduct.map((product) => product.key),
        filter_type: "product",
      };
      this.$http
        .post(url, payload)
        .then((res) => {
          this.ratingCountTableShow = res.data.data_present;
          this.ratingTableloader = false;
          this.ratingCountList = res.data;
          this.$nextTick(() => {
            this.processRatingTable("#rating-table");
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    processRatingTable(id, sortCol = 0) {
      if ($.fn.DataTable.isDataTable(id)) {
        $(id).DataTable().destroy();
      }

      $(id).DataTable().destroy();
      $(id).DataTable({
        searching: true,
        info: true,
        sorting: [[sortCol, "desc"]],
        // scrollY: scrollVertical || false,
        initComplete: function (settings, json) {
          $(id).wrap(
            "<div style='overflow:auto; width:100%;position:relative;'></div>"
          );
        },
        language: {
          search: "",
          searchPlaceholder: "Search...",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: "",
          },
          lengthMenu: "<h5>Show entries</h5> _MENU_",
        },
      });

      $(id + "_filter > label").append(`
        <div class='search_icon'>
            <img src='/Icons_SVG/Search.svg' width='20' />
        </div>
        `);
    },
  },
};
</script>
<style scoped>
.rating-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 5%;
}

.ratings-group {
  display: grid;
  width: 90%;
  height: 15px;
  border: 1px solid #d9d9d9;
  border-radius: 10px;

  & > * {
    grid-column: 1;
    grid-row: 1;
  }
}

.inactive-ratings-bar {
  width: 100%;
  background-color: #f4f4f4;
  border: none;
  border-radius: 10px;
}

.active-ratings-bar {
  border-radius: 10px;
}

.breakdown-star {
  display: flex;
  width: 24px;
  margin-right: 0px;
  color: #fcb117;
  fill: #fcb117;
}

.star-tooltip {
  position: relative;
  cursor: pointer;
}

.star-tooltiptext {
  visibility: hidden;
  width: 250px;
  padding: 2px 2px;
  background-color: #ffffff;
  color: #000;
  border-radius: 6px;
  text-align: center;
  position: absolute;
  z-index: 7777 !important;
  bottom: 125%;
  left:10%;
  margin-left: -60px;
  opacity: 0;
  font-size: 12px;
  transition: opacity 0.3s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.star-tooltip:hover .star-tooltiptext {
  visibility: visible;
  opacity: 1;
}

.insight-container {
  padding: 6px 12px;
  margin-block: 12px;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
}

.keyword {
  color: #0463ba !important;
  font-family: Poppins !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 25px !important;
}

.modal-control-panel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #d4d4d4;

  & > ul {
    list-style: none;
    display: flex;
    align-items: center;
    gap: 20px;
    margin: 0;
    padding: 0;

    & > li {
      padding-bottom: 16px;
      margin: 0;
      font-size: 16px;
      cursor: pointer;
    }

    & > li.selected-tab {
      border-bottom: 1px solid #065559;
      margin-bottom: -1px;
      color: #065559;
      font-weight: 500;
    }
  }
}

.horizontal-divider {
  border-bottom: 1px solid #d9d9d9;
}

.vertical-divider {
  border-right: 1px solid #d9d9d9;
}

.customInput {
  border-radius: 5px !important;
  height: 35px !important;
  border: 1px solid #e4e7ea;
  width: 220px;
  outline: none;
  font-family: "poppins";
  width: 100%;
}

.customInput:focus {
  border: 1px solid var(--primary_brand) !important;
  box-shadow: none !important;
}

.delete-viewBtn:hover {
  background-color: #f58181 !important;
}

.delete-alert {
  background-color: #ffecec !important;
  color: var(--red);
  font-size: 30px;
  width: 45px;
  height: 45px;
}

.graphHeading {
  font-weight: 600 !important;
  font-size: 16px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
  text-transform: capitalize;
}

.grayedHeading {
  font-weight: 600 !important;
  font-size: 16px !important;
  color: var(--base_color-60) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
  text-transform: capitalize;
}

.newComparisonIcon svg {
  height: 17px;
  transform: rotate(45deg);
  color: white;
  fill: #fff;
  margin-right: 5px;
}

.close-card {
  position: absolute;
  right: 20px;
  top: 5px;
  background-color: #dedede;
  padding: 6px 10px;
  border-radius: 50%;
  cursor: pointer;
}

.close-card:hover {
  background-color: #f0f0f0;
}

.card-heading {
  padding-bottom: 10px;
  border-bottom: 1px solid #d4d4d4;

  & > p {
    font-size: 16px;
    font-weight: 600;
    line-height: 21.76px;
    color: #065559;
  }
}

.add-comparison {
  border: 1px solid #d9d9d9;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  height: 200px;
  border-radius: 10px;
  color: #5e5e5e;
}

.plus-icon {
  font-size: 30px;
  color: #5e5e5e;
  border: 2px dashed #5e5e5e;
  border-radius: 50%;
  padding-inline: 12px;
  cursor: pointer;
}

.customselect {
  height: 37px !important;
  border-radius: 5px !important;
  background: white;
  border: 1px solid #b7b7b7 !important;
  padding-left: 11px;
  padding-right: 11px;
  margin-right: 5px;
  color: var(--primary_brand);
  width: 90%;
  text-overflow: ellipsis;
}

.customselect:focus {
  outline: none !important;
  border: 1px solid var(--primary_brand) !important;
}

.compare-card {
  background-color: white;
  border-radius: 10px;
  border: 1px solid #d9d9d9;
}

.multiline-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
  text-overflow: ellipsis;
}

.container {
  display: grid;
  align-items: center;
  justify-content: start;
  margin: 0;
  padding: 0;

  & > * {
    grid-column: 1;
    grid-row: 1;
  }
}

.star {
  display: flex;
  width: 16px;
  margin-right: 0px;
  color: #fcb117;
  fill: #fcb117;
}

.overlay {
  justify-self: end;
  background-color: white;
  height: 16px;
}

ul.tabs {
  display: flex;
  justify-content: flex-start;
  gap: 8px;
  margin: 0;
  padding: 0;
  border-bottom: 1px solid#D5D5D5;

  & > li {
    list-style: none;
    padding-inline: 8px;
    padding-bottom: 14px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
  }

  & > li.active {
    color: #065559;
    border-bottom: 1px solid var(--primary_brand);
  }
}

.slide {
  display: flex;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;

  & > * {
    min-width: 100%;
  }
}

.slide::-webkit-scrollbar {
  display: none;
}

.tab {
  width: 30px;
  height: 7px;
  border-radius: 10px;
  background-color: #0655594d;
  cursor: pointer;
}

.active-tab {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: #00555a;
  cursor: pointer;
}

.slider-tab {
  width: 30px;
  height: 7px;
  border-radius: 10px;
  background-color: #0655594d;
  cursor: pointer;
}

.slider-active {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: #00555a;
  cursor: pointer;
}

.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 7px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 14px;
}

button.navigation-btn {
  background: var(--accent_color);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 7px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 14px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}

button.navigation-btn:hover {
  background: var(--accent_color-80);
}

.label {
  font-size: 14px;
  font-weight: 500;
  color: #1e1e1e;
}

.gap {
  gap: 14px !important;
}

.customSelect :focus {
  background: var(--base_color-5) !important;
  color: var(--primary_brand-60) !important;
  border: 1px solid var(--primary_brand-60) !important;
  outline: none !important;
  box-shadow: none !important;
  font-weight: 600;
}

.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 12px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}

.section-button {
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid #065559;
  background-color: transparent;
  font-size: 14px;
  font-weight: 400;
  line-height: 19.04px;
  color: #00555a;
}

.active-button {
  background-color: #065559;
  color: white;
}

.product-section-card {
  border-radius: 10px;
  border: 1px solid #d9d9d9;
  background-color: transparent;
  height: 100%;
}

.logo-container {
  border-radius: 10px;
  border: 0px solid #d9d9d9;
  background: linear-gradient(
    360deg,
    rgba(0, 0, 0, 0.05) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  box-shadow: 0px 1px 6px 0px #0000002e;
  max-height: 220px;
  max-width: 100%;
}

a {
  color: #0463ba;
  font-family: Poppins;
  font-size: 14px;
  font-weight: 500;
  line-height: 25px;
  text-transform: capitalize;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.tree-leaf {
  height: 25px;
  margin: auto;
  line-height: 25px;
  cursor: pointer;
}

/* datatable */
.dataTables_filter div {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-left: -15px;
  background-color: var(--primary_brand);
}
div.dataTables_filter input{
  border: 1px solid #065559;
}

.dataTables_filter img {
  height: 17px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg)
    brightness(103%) contrast(104%);
}

table.dataTable th {
  background-color: #e7eeef !important;
  padding: 16px 32px !important;
  font-family: "Poppins", sans-serif !important;
  font-size: 14px !important;
  font-weight: 600 !important;
}

table.dataTable > thead > tr:first-child > th:first-child {
  border-top-left-radius: 5px !important;
}

table.dataTable > thead > tr:first-child > th:last-child {
  border-top-right-radius: 5px !important;
}

table.dataTable > tbody > tr > td {
  font-family: "Poppins", sans-serif !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  color: black !important;
}

thead {
  background: none !important;
}

.dataTables_info {
  position: relative;
  top: 9px;
  left: 0;
  z-index: 100;
  float: none;
  width: auto;
  font-size: 15px;
  color: var(--primary_brand-80);
}

.dataTables_paginate {
  position: relative;
  top: 6px;
  z-index: 100;
  float: right;
}

.customMultiselect .multiselect__placeholder {
  margin-bottom: 6px !important;
  padding: 0px !important;
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tags {
  border: 1px solid var(--base_color-40) !important;
  padding-top: 6px !important;
  min-height: 35px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__select {
  min-height: 35px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__select::before {
  top: 56% !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tag {
  background: var(--primary_brand-80) !important;
  margin-bottom: 0px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tag-icon:after {
  color: #fff !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__content-wrapper {
  border: 1px solid var(--base_color-40) !important;
  border-top: none !important;
  font-family: "poppins";
}

.customMultiselect
  .multiselect__option--selected.multiselect__option--highlight {
  background: var(--red) !important;
  color: var(--white) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__option--highlight {
  background: var(--base_color-20) !important;
  color: var(--primary_brand-80) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__element {
  color: var(--primary_brand-80) !important;
  border-bottom: 1px solid var(--base_color-20);
  font-family: "poppins";
}

/* width */
.customMultiselect ::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}

/* Track */
.customMultiselect ::-webkit-scrollbar-track {
  background: var(--base_color-20);
  border-radius: 10px;
}

/* Handle */
.customMultiselect ::-webkit-scrollbar-thumb {
  background: var(--base_color-80);
  border-radius: 10px;
}

/* Handle on hover */
.customMultiselect ::-webkit-scrollbar-thumb:hover {
  background: var(--base_color);
}

.thin-scrollerBar::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
  border-radius: 6px;
  background: #ebedee;
}

.thin-scrollerBar::-webkit-scrollbar {
  height: 6px;
  width: 6px;
}

.thin-scrollerBar::-webkit-scrollbar-thumb {
  border-radius: 6px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: #b3b2b9;
}

.thin-scrollerBar::-webkit-scrollbar-thumb:hover {
  background: #8b8d94;
  cursor: pointer;
}

.inSightsContainer {
  border-radius: 5px !important;
  border: 1px solid #d9d9d9;
}

.inSightsContainer > div:first-child {
  border-right: 1px solid #d9d9d9;
}

.insightsContent {
  font-weight: 400;
  font-size: 14px;
  color: #1e1e1e;
}
#reviewLineChart .highcharts-root{
  height:450px !important;
}
#reviewLineChart .highcharts-container{
  height:450px !important;
}
</style>
